/**
 * 招商管理模块翻译 - 中文
 * 包含：品牌、商户、政策、工作台、洽谈、意向、计划、任务、合同、业态规划、落位
 */
export default {
  merchant: {
    // ==================== 品牌管理 brand ====================
    brand: {
      title: '品牌管理',
      brandName: '品牌名称',
      brandCode: '品牌编码',
      brandLevel: '品牌等级',
      brandType: '品牌类型',
      brandDescription: '品牌介绍',
      contactPerson: '联系人',
      contactPhone: '联系电话',
      contactEmail: '联系邮箱',
      foundingYear: '创立年份',
      headquarters: '总部地址',
      website: '官网地址',
      cooperationCases: '合作案例',
      cooperationCasesPlaceholder: '请输入合作案例（如：XX广场、XX购物中心）',
      isPreferred: '首选',
      isAlternative: '备选',
      preferredBrand: '首选品牌',
      alternativeBrand: '备选品牌',
      approvalStatus: '审核状态',
      cooperationStatus: '合作状态',
      keyword: '关键字',
      keywordPlaceholder: '请输入品牌名称/编码/联系人',
      // 品牌等级选项
      levelInternational: '国际品牌',
      levelNational: '国内品牌',
      levelOrdinary: '普通品牌',
      // 品牌类型选项
      typeAnchor: '主力店',
      typeSubAnchor: '次主力',
      typeStandard: '散铺',
      // 审核状态选项
      approvalPending: '待审核',
      approvalApproved: '已通过',
      approvalRejected: '已驳回',
      // 合作状态选项
      coopAvailable: '可合作',
      coopIntention: '意向中',
      coopCooperating: '合作中',
      coopSuspended: '暂停合作',
      coopBlacklisted: '黑名单',
      // 经营条件
      businessConditions: '经营条件',
      rentTolerance: '租金承受力',
      rentToleranceUnit: '元/㎡/月',
      minArea: '最小面积',
      maxArea: '最大面积',
      areaRange: '面积需求',
      needExhaust: '需要排烟',
      needPower: '需独立电表',
      powerDemand: '电量需求',
      powerDemandPlaceholder: '请输入电量需求说明',
      // 状态与设置
      statusAndSettings: '状态与设置',
      basicInfo: '基本信息',
      contactInfo: '联系方式',
      businessCondition: '经营条件',
      sortOrder: '显示排序',
      // 弹窗标题
      addBrand: '添加品牌',
      editBrand: '修改品牌',
      brandDetail: '品牌详情',
      // 操作
      approvePass: '审核通过',
      approveReject: '审核驳回',
      suspendCooperation: '暂停合作',
      resumeCooperation: '恢复合作',
      addToBlacklist: '加入黑名单',
      removeFromBlacklist: '移出黑名单',
      setPreferred: '设为首选',
      cancelPreferred: '取消首选',
      // 确认提示
      deleteConfirm: '是否确认删除该品牌？',
      batchDeleteConfirm: '是否确认删除选中的品牌？',
      blacklistConfirm: '确认将该品牌加入黑名单？',
      // 成功消息
      approvedSuccess: '审核通过',
      rejectedSuccess: '已驳回',
      suspendedSuccess: '已暂停合作',
      resumedSuccess: '已恢复合作',
      blacklistedSuccess: '已加入黑名单',
      unblacklistedSuccess: '已移出黑名单',
      // 标签
      industry: '所属行业',
      // 验证
      brandNameRequired: '品牌名称不能为空',
      brandCodeRequired: '品牌编码不能为空',
      brandLevelRequired: '品牌等级不能为空',
      industryRequired: '所属行业不能为空',
      phoneInvalid: '请输入正确的手机号码',
      emailInvalid: '请输入正确的邮箱地址',
      autoGenerate: '自动生成',
    },

    // ==================== 商户信息 info ====================
    info: {
      title: '商户信息',
      merchantName: '商户名称',
      merchantCode: '商户编码',
      autoGenerateCode: '系统自动生成',
      merchantLevel: '商户等级',
      merchantType: '商户类型',
      merchantStatus: '商户状态',
      merchantDescription: '商户介绍',
      contactPerson: '联系人',
      contactPhone: '联系电话',
      contactEmail: '联系邮箱',
      foundingYear: '创立年份',
      headquarters: '总部地址',
      website: '官网地址',
      isPreferred: '首选',
      preferredMerchant: '首选商户',
      alternativeMerchant: '备选商户',
      sortOrder: '显示排序',
      keyword: '关键字',
      keywordPlaceholder: '请输入商户名称/编码/联系人',
      // 等级选项
      levelInternational: '国际商户',
      levelNational: '国内商户',
      levelOrdinary: '普通商户',
      // 类型选项
      typeCompany: '公司',
      typeIndividual: '个人',
      typeFranchise: '加盟',
      // 状态选项
      statusPotential: '潜在客户',
      statusIntention: '意向客户',
      statusSigned: '签约客户',
      // Tab标题
      tabBasic: '基本信息',
      tabEnterprise: '企业信息',
      tabFinance: '财务信息',
      tabBusiness: '业务信息',
      // 企业信息
      legalPerson: '法人代表',
      legalPersonPlaceholder: '请输入法定代表人',
      businessLicense: '营业执照号',
      registeredCapital: '注册资本',
      registeredCapitalUnit: '万元',
      establishedDate: '成立日期',
      businessScope: '经营范围',
      registeredAddress: '注册地址',
      officeAddress: '办公地址',
      // 财务信息
      bankName: '开户银行',
      bankAccount: '银行账号',
      accountName: '户名',
      taxNumber: '税号',
      // 业务信息
      relatedBrand: '关联品牌',
      creditRating: '信用评级',
      cooperationHistory: '合作历史',
      cooperationHistoryPlaceholder: '请输入合作历史描述',
      // 弹窗标题
      addMerchant: '添加商户',
      editMerchant: '修改商户',
      merchantDetail: '商户详情',
      // 操作
      setPreferred: '设为首选',
      cancelPreferred: '取消首选',
      // 确认提示
      deleteConfirm: '是否确认删除该商户？',
      batchDeleteConfirm: '是否确认删除选中的商户？',
      // 标签
      industry: '所属行业',
      // 验证
      merchantNameRequired: '商户名称不能为空',
      merchantCodeRequired: '商户编码不能为空',
      merchantLevelRequired: '商户等级不能为空',
      industryRequired: '所属行业不能为空',
      phoneInvalid: '请输入正确的手机号码',
      emailInvalid: '请输入正确的邮箱地址',
      // 成功消息
      enabledSuccess: '启用成功',
      disabledSuccess: '禁用成功',
    },

    // ==================== 政策管理 policy ====================
    policy: {
      title: '政策管理',
      policyName: '政策名称',
      year: '年度',
      resourceType: '资源类型',
      effectiveDate: '生效日期',
      expiryDate: '失效日期',
      keyword: '关键字',
      keywordPlaceholder: '请输入政策名称',
      allYears: '全部年度',
      // 状态
      statusEnabled: '启用',
      statusDisabled: '停用',
      // 操作
      resourcePolicy: '资源政策',
      // 确认
      deleteConfirm: '是否确认删除该招商政策？删除后其下所有资源政策也将被删除。',
      batchDeleteConfirm: '是否确认删除选中的 {count} 条政策？',
      // 成功消息
      enableSuccess: '启用成功',
      disableSuccess: '停用成功',
      // 政策表单
      addPolicy: '新增招商政策',
      editPolicy: '修改招商政策',
      policyDetail: '政策详情',
      coreInfo: '核心信息',
      project: '所属项目',
      projectPlaceholder: '请选择项目',
      projectRequired: '请选择所属项目',
      yearRequired: '请选择年度',
      yearPlaceholder: '请选择年度',
      policyNameRequired: '请输入政策名称',
      policyNamePlaceholder: '如：餐饮铺位V202601',
      policyType: '政策类型',
      policyTypeRent: '租金策略',
      policyTypePromotion: '促销策略',
      policyTypeOther: '其他',
      // 租金策略
      rentStrategy: '租金策略',
      rentCalculation: '计租方式',
      rentFixed: '固定租金',
      rentCommission: '扣点',
      rentGuaranteedHigher: '保底取高',
      rentFixedPlusExcess: '固定+超额',
      standardRent: '标准租金',
      commissionShort: '扣点',
      minRent: '最低租金',
      maxRent: '最高租金',
      managementFee: '物业费',
      managementFeeLabel: '物业管理费',
      promotionFund: '推广基金',
      commissionRate: '扣点比例',
      guaranteedAmount: '保底金额',
      excessThreshold: '超额起算',
      // 合同与优惠
      contractAndIncentive: '合同与优惠',
      minLeaseYears: '最短年限',
      minLeaseYearsLabel: '最短合同年限',
      maxLeaseYears: '最长年限',
      maxLeaseYearsLabel: '最长合同年限',
      paymentMethod: '付款方式',
      paymentCycle: '付款周期',
      paymentMonthly: '月付',
      paymentQuarterly: '季付',
      paymentSemiAnnual: '半年付',
      paymentYearly: '年付',
      depositMonths: '保证金',
      depositMonthsLabel: '保证金月数',
      rentFree: '装修免租',
      rentFreePeriod: '装修免租期',
      operationFree: '经营免租',
      operationFreePeriod: '经营免租期',
      decorationPeriod: '装修期',
      decorationSubsidy: '装修补贴',
      annualIncreaseRate: '年递增率',
      increaseCycle: '递增周期',
      // 专项配置
      specialConfig: '专项配置',
      specialConfigTip: '选择资源类型后展开对应的专项字段，可选配置，不设置不影响保存',
      assetTypeLabel: '资源类型',
      assetTypePlaceholder: '请选择（可选）',
      clearSpecialConfig: '清除专项配置',
      specialConfigUnsavedTip: '专项配置中有未保存的数据，确定要关闭吗？',
      closeConfirm: '关闭确认',
      tabBasicPolicy: '基本政策',
      selectAssetTypeFirst: '请先选择资源类型以展开专项配置',
      // 表单操作
      formNotReady: '表单未就绪，请稍后重试',
      checkRequired: '请检查表单必填项',
      editFailed: '修改失败',
      addFailed: '新增失败',
      loadDetailFailed: '加载政策详情失败',
      // 单位
      unitYuanPerSqmMonth: '元/㎡/月',
      unitYuanPerMonth: '元/月',
      unitPercent: '%',
      unitYear: '年',
      unitMonth: '月',
      unitYuan: '元',
      unitSqm: '㎡',
      // 详情页面 - 区块标题
      sectionBasicInfo: '基本信息',
      sectionAssetInfo: '关联铺位',
      sectionRentStrategy: '租金策略',
      sectionContractIncentive: '合同与优惠',
      sectionSystemInfo: '系统信息',
      // 详情页面 - 标签
      createdBy: '创建人',
      updatedBy: '更新人',
      shopLabel: '铺位',
      areaLabel: '面积',
      buildingLabel: '楼栋',
      floorLabel: '楼层',
      // 资源政策页面
      assetPolicy: '资源政策',
      baseRent: '基准租金',
      searchAssetPlaceholder: '搜索资源编号/名称',
      addResource: '添加资源',
      batchAdd: '批量添加',
      assetCode: '资源编号',
      assetName: '资源名称',
      buildingFloor: '楼栋/楼层',
      areaSqm: '面积(㎡)',
      shopType: '铺位类型',
      comparisonBase: '对比基准',
      comparisonBaseline: '基准',
      addResourceDialog: '添加资源',
      building: '楼栋',
      buildingPlaceholder: '请选择楼栋',
      floor: '楼层',
      floorPlaceholder: '请选择楼层',
      shopTypePlaceholder: '铺位类型',
      confirmAdd: '确认添加',
      selectAtLeastOne: '请选择至少一个资源',
      addResourceSuccess: '成功添加 {count} 个资源政策',
      addResourceFailed: '添加资源政策失败',
      loadParentFailed: '加载大政策信息失败',
      loadAssetListFailed: '加载资源政策列表失败',
      loadAvailableFailed: '加载可用资源列表失败',
      deleteAssetConfirm: '是否确认删除该资源政策？',
      // 铺位类型映射
      shopTypeRetail: '零售',
      shopTypeFood: '餐饮',
      shopTypeEntertainment: '娱乐',
      shopTypeService: '服务',
      // 资产状态映射
      assetStatusAvailable: '可租',
      assetStatusRented: '已租',
      assetStatusMaintenance: '维护中',
      assetStatusReserved: '预留',
      // 资源政策表单
      assetPolicyTitle: '编辑资源政策',
      assetInfo: '资源信息',
      parentPolicyLabel: '所属大政策',
      assetStatus: '资产状态',
      saveFailed: '保存失败',
      // 动态字段组 fieldGroups
      fg: {
        groupBasic: '基本信息',
        groupRent: '租金策略',
        groupRentSimple: '租金标准',
        groupManagement: '物管费用',
        groupLeaseTerm: '合同期限',
        groupLeaseTermSimple: '租赁期限',
        groupIncentive: '优惠激励',
        groupIncentiveSimple: '优惠条件',
        groupIncrement: '租金递增',
        groupCoefficient: '系数设置',
        groupBrand: '品牌要求',
        groupOperation: '经营要求',
        groupLayout: '业态布局',
        groupBilling: '计费策略',
        groupRestriction: '限制条件',
        policyName: '政策名称',
        policyType: '政策类型',
        effectiveDate: '生效日期',
        expiryDate: '失效日期',
        rentCalculation: '计租方式',
        standardRent: '标准租金',
        minRent: '最低租金',
        maxRent: '最高租金',
        commissionRate: '扣点比例',
        guaranteedAmount: '保底金额',
        excessThreshold: '超额起算额',
        managementFee: '物业管理费',
        promotionFund: '推广基金',
        minLeaseYears: '最短合同年限',
        maxLeaseYears: '最长合同年限',
        paymentMethod: '付款方式',
        depositMonths: '保证金月数',
        minRentalPeriod: '最短租赁期',
        maxRentalPeriod: '最长租赁期',
        rentFreePeriod: '装修免租期',
        operationFreePeriod: '经营免租期',
        decorationPeriod: '装修期',
        decorationSubsidy: '装修补贴',
        freePeriod: '免租期',
        annualIncreaseRate: '年递增率',
        increaseCycle: '递增周期',
        floorCoefficient: '楼层系数',
        positionCoefficient: '位置系数',
        rentAreaType: '计租面积',
        brandLevel: '品牌等级要求',
        preferredBrands: '首选品牌',
        alternativeBrands: '备选品牌',
        minTurnover: '最低营业额',
        minEfficiency: '最低坪效',
        operationHours: '营业时间',
        exclusivityClause: '排他条款',
        businessType: '业态ID',
        layoutRequirements: '布局要求',
        otherConditions: '其他条件',
        billingCycle: '计费周期',
        standardPrice: '标准价格',
        minPrice: '最低价格',
        maxPrice: '最高价格',
        industryRestriction: '行业限制',
        priorityRules: '优先规则',
        allowedCategories: '允许品类',
        safetyRequirements: '安全要求',
        usagePermission: '使用许可',
        restrictions: '限制条件',
        unitYuanSqmMonth: '元/㎡/月',
        unitPercent: '%',
        unitYuanMonth: '元/月',
        unitYear: '年',
        unitMonth: '个月',
        unitDay: '天',
        unitYuan: '元',
        optRentStrategy: '租金策略',
        optPromotionStrategy: '促销策略',
        optOther: '其他',
        optRentFixed: '固定租金',
        optRentCommission: '扣点',
        optRentGuaranteed: '保底取高',
        optRentFixedPlusExcess: '固定+超额',
        optPayMonthly: '月付',
        optPayQuarterly: '季付',
        optPaySemiAnnual: '半年付',
        optPayYearly: '年付',
        optAreaBuilding: '建筑面积',
        optAreaUsable: '使用面积',
        optBrandIntlTop: '国际一线',
        optBrandIntlSecond: '国际二线',
        optBrandNatTop: '国内一线',
        optBrandNatSecond: '国内二线',
        optBrandRegional: '区域品牌',
        optBrandAny: '不限',
        optBillingDay: '按天',
        optBillingWeek: '按周',
        optBillingMonth: '按月',
        optBillingYear: '按年',
        optBillingSession: '按场次',
        phPolicyName: '请输入政策名称',
        phEffectiveDate: '请选择生效日期',
        phExpiryDate: '请选择失效日期',
        phPreferredBrands: '多个品牌用逗号分隔',
        phAlternativeBrands: '多个品牌用逗号分隔',
        phOperationHours: '如：10:00-22:00',
        phExclusivityClause: '请输入排他性条款说明',
        phBusinessTypeId: '请输入业态ID',
        phLayoutRequirements: '请输入布局要求',
        phOtherConditions: '请输入其他条件说明',
        phIndustryRestriction: '请输入行业限制说明',
        phPriorityRules: '请输入优先规则说明',
        phAllowedCategories: '请输入允许品类',
        phSafetyRequirements: '请输入安全要求',
        phUsagePermission: '请输入使用许可说明',
        phRestrictions: '请输入限制条件说明',
      },
    },

    // ==================== 合同管理 contract ====================
    contract: {
      title: '合同管理',
      contractNo: '合同编号',
      manualContractNo: '手工合同号',
      erpNo: 'ERP合同号',
      thirdMerchantId: '第三方商户ID',
      merchantName: '商户名称',
      shopName: '资产',
      leaseArea: '租赁面积',
      brandName: '品牌',
      standardRent: '标准租金',
      contractPeriod: '合同期限',
      contractStatus: '合同状态',
      backToList: '返回列表',
      addContract: '新增合同',
      // 合同状态
      statusDraft: '草稿',
      statusPending: '待审核',
      statusActive: '生效中',
      statusPendingEffective: '待生效',
      statusExpired: '已到期',
      statusTerminated: '已终止',
      // 操作
      activate: '生效',
      terminate: '终止',
      revoke: '撤销',
      submitApproval: '提交审批',
      withdrawApproval: '撤回审批',
      approve: '审批',
      // 审批消息
      submitApprovalConfirm: '确定要提交该合同进行审批吗？',
      withdrawApprovalConfirm: '确定要撤回该合同的审批吗？',
      submitApprovalSuccess: '已提交审批，请等待审批结果',
      submitDirectSuccess: '合同已直接生效（未配置审批流程）',
      withdrawSuccess: '审批已撤回',
      withdrawFailed: '撤回失败',
      approvalRunning: '该合同已有进行中的审批流程',
      // Tab
      tabApprovalHistory: '审批记录',
      // 确认
      deleteConfirm: '确定要删除该合同吗？',
      statusChangeConfirm: '确定要将合同设为"{status}"状态吗？',
      confirmAction: '确认操作',
      // 成功消息
      statusUpdateSuccess: '状态更新成功',
      statusUpdateFailed: '状态更新失败',
      createSuccess: '创建成功',
      updateSuccess: '更新成功',
      loadDetailFailed: '加载合同详情失败',
      // Tab标题
      tabBasic: '基本信息',
      tabRent: '租金条款',
      tabTerms: '合同约定',
      // 搜索
      keyword: '关键字',
      keywordPlaceholder: '合同号/商户名/铺位',
      merchant: '商户',
      allMerchants: '全部商户',
      // 基本信息
      basicInfo: '合同基础信息',
      autoGenerate: '自动生成',
      signingDept: '签约部门',
      signingPerson: '招商人员',
      merchantInfo: '商户信息',
      signDate: '签订日期',
      meetingDate: '经理办公会日期',
      cosignDate: '会签日期',
      sealDate: '用印日期',
      freeParkingCount: '赠送车位',
      maxParkingApply: '最大申请车位',
      unitCount: '个',
      signingCompany: '收费主体',
      shopInfo: '商铺信息',
      assetInfo: '资产信息',
      assetType: '资产类型',
      periodInfo: '合同期限',
      contractStart: '合同开始',
      contractEnd: '合同结束',
      renovationStart: '装修期开始',
      renovationEnd: '装修期结束',
      openingDate: '开业日期',
      selectDate: '选择日期',
      // 收款方式
      paymentCollectionInfo: '收款方式',
      paymentCollectionType: '收款方式',
      paymentCollectionUnified: '统收',
      paymentCollectionSelf: '自收',
      businessType: '业态',
      salesDept: '销售部门',
      category: '经营分类',
      categoryPlaceholder: '请先选择业态再选择分类',
      salesCollectionMethod: '销售采集方式',
      salesMethodPOS: 'POS',
      salesMethodMerchant: '商户提报',
      salesMethodAuto: '自动采集',
      salesMethodOther: '其他',
      // 铺位多选
      selectShop: '选择铺位',
      addShop: '+ 添加铺位',
      selectedShops: '已选铺位',
      totalArea: '合计面积',
      unitCount: '个',
      selectedCount: '已选',
      refPriceHint: '参考价（来自资产档案）',
      // 品牌多选
      addBrand: '+ 添加品牌',
      clickToSetMainBrand: '点击品牌标签前的 ★ 可设置为主品牌',
      // 收费主体多选
      addCompany: '+ 添加公司',
      // 租金条款
      rentCalculation: '计租方式',
      rentFixed: '固定租金',
      rentCommission: '扣点',
      rentGuaranteedHigher: '保底取高',
      rentStandard: '租金标准',
      commissionRate: '扣点比例',
      guaranteedAmount: '保底金额',
      managementFee: '物业费',
      promotionFund: '推广基金',
      freeRentAndIncrease: '免租与递增',
      rentFreePeriod: '装修免租期',
      operationFreePeriod: '经营免租期',
      annualIncreaseRate: '年递增率',
      increaseCycle: '递增周期',
      depositAndPayment: '保证金与付款',
      deposit: '保证金',
      depositMonths: '保证金月数',
      paymentMethod: '付款方式',
      paymentMonthly: '月付',
      paymentQuarterly: '季付',
      paymentSemiAnnual: '半年付',
      paymentYearly: '年付',
      // 合同约定
      specialTerms: '特殊条款',
      specialTermsPlaceholder: '请输入特殊条款',
      attachments: '合同附件',
      attachment: '附件',
      uploadAttachment: '上传附件',
      uploadTip: '支持常见文档和图片格式，单文件不超过20MB，最多10个附件',
      noAttachment: '暂无附件',
      uploadSuccess: '{name} 上传成功',
      uploadFailed: '{name} 上传失败',
      fileSizeLimit: '文件大小不能超过20MB',
      fileCountLimit: '最多上传10个附件',
      // 验证
      merchantRequired: '请选择商户',
      shopRequired: '请选择铺位',
      startDateRequired: '请选择开始日期',
      endDateRequired: '请选择结束日期',
      deptRequired: '请选择签约部门',
      signPersonRequired: '请选择招商人员',
      businessTypeRequired: '请选择业态',
      categoryRequired: '请选择经营分类',
      salesDeptRequired: '请选择销售部门',
      brandRequired: '请选择品牌',
      signCompanyRequired: '请选择收费主体',
      openingDateRequired: '请选择预计开业日期',
      // 单位
      unitYuanPerSqmMonth: '元/㎡/月',
      unitYuanPerMonth: '元/月',
      unitPercent: '%',
      unitMonth: '月',
      unitYear: '年',
      unitYuan: '元',
      unitSqm: '㎡',
      // 格式化
      periodTo: '至',
      // 铺位带入
      policyDataImported: '已从铺位关联政策导入定价信息',
      shopDataImported: '已从铺位导入基础定价',
      // 从意向创建
      createFromIntention: '从意向创建',
      createFromIntentionSuccess: '已从意向创建合同草稿',
      selectIntention: '选择意向',
      selectIntentionHint: '选择一条有效意向，将自动创建合同草稿并带入意向中的信息',
      intentionNo: '意向编号',
      intentionMerchant: '商户',
      intentionBrand: '品牌',
      intentionShop: '铺位',
      intentionRent: '拟议租金',
      intentionArea: '拟议面积',
      intentionPeriod: '拟议期限',
      noActiveIntention: '暂无有效意向',
      searchIntentionPlaceholder: '搜索意向编号/商户/品牌/铺位',
      confirmCreateFromIntention: '确认从该意向创建合同草稿？',
      // 分段配置
      tabPeriod: '分段配置',
      // 合同变更
      submitAmendment: '提交变更',
      originalContract: '原合同信息',
      shop: '铺位',
      rentInfo: '租金信息',
      periodInfo: '期限信息',
      amendmentType: '变更类型',
      amendmentTypeRent: '租金调整',
      amendmentTypeRate: '费率调整',
      amendmentTypeTerm: '期限调整',
      amendmentTypeFee: '费用调整',
      amendmentTypeComprehensive: '综合调整',
      effectiveDate: '生效日期',
      effectiveDateRequired: '请选择生效日期',
      amendmentReason: '变更原因',
      amendmentReasonPlaceholder: '请输入变更原因',
      amendmentContent: '变更内容',
      signPerson: '签约人',
      signCompany: '收费主体',
      periodEdit: '分段编辑',
      periodTitle: '第{num}期',
      periodName: '分段名称',
      startDate: '开始日期',
      endDate: '结束日期',
      increaseRate: '递增率',
      changeSummary: '变更汇总',
      amendmentStatusDraft: '草稿',
      amendmentStatusPending: '待审批',
      amendmentStatusApproved: '已通过',
      amendmentStatusRejected: '已驳回',
      submitAmendmentConfirm: '确定要提交该合同变更吗？',
      submitAmendmentSuccess: '已提交变更审批',
      revokeAmendment: '撤销变更',
      revokeAmendmentConfirm: '确定要撤销该合同变更吗？',
      revokeAmendmentSuccess: '变更已撤销',
      tabBasic: '基本信息',
      tabRent: '租金条款',
      tabTerms: '合同约定',

      // ==================== 合同分段 period ====================
      period: {
        // 提示
        tipTitle: '操作说明：',
        tipContent: '1. 点击「按自然年拆分」或「按合同年拆分」可自动生成分段，然后手动调整；2. 每个分段内配置时间、租金、费用、免租期和付款方式；3. 月度分解区分自然月和合同月。',
        // 工具栏
        configTitle: '分段配置',
        contractPeriod: '合同期',
        totalYears: '共{years}年',
        splitNaturalYear: '按自然年拆分',
        splitContractYear: '按合同年拆分',
        addPeriod: '手动添加分段',
        // 分段卡片
        yearTitle: '第{num}年度',
        firstNonFull: '首年非整年',
        newPeriod: '新分段',
        copy: '复制',
        months: '个月',
        monthsUnit: '月',
        increaseTag: '递增',
        freeRentTag: '免租{count}段',
        // 时间设置
        timeSetting: '时间段设置',
        periodName: '分段名称',
        periodNamePlaceholder: '如：第一年度',
        startDate: '开始日期',
        endDate: '结束日期',
        // 租金设置
        rentSetting: '租金设置',
        rentCalcType: '计租方式',
        rentFixed: '固定租金',
        rentCommission: '扣点租金',
        rentOrCommission: '固定与扣点取高',
        rentPlusCommission: '固定+扣点',
        rentGuaranteed: '保底+扣点取高',
        commissionRate: '扣点比例',
        commissionCalcType: '扣率计算方式',
        commissionFlat: '打通计算',
        commissionTiered: '阶梯分段',
        commissionFlatHint: '根据销售额匹配档位，全部销售额按该档位扣率计算',
        commissionTieredHint: '各档位销售额分别按对应扣率计算后累加',
        commissionTiers: '阶梯扣率配置',
        tierIndex: '档位',
        salesStart: '销售额起点',
        salesEnd: '销售额终点',
        addCommissionTier: '+ 添加扣率档位',
        guaranteedAmount: '保底金额',
        rentCalcDimension: '计算维度',
        // 维度 = 录入口径。业务默认录「月租金总价」；仅选面积单价时才按面积换算
        dimensionMonthly: '月租金总价（元/月）',
        dimensionSqMonthly: '面积月单价（元/㎡/月，×面积）',
        dimensionSqDaily: '面积日单价（元/㎡/天，×面积×天）',
        dimensionYearly: '面积年单价（元/㎡/年，÷12）',
        dimensionDaily: '日租金金额（元/天，×当月天数）',
        standardRent: '租金标准',
        standardRentUnitPrice: '租金单价',
        standardRentFixedAmount: '租金金额',
        monthlyRentInput: '月租金',
        monthlyRent: '折合月租金',
        monthlyRentUnit: '元/月',
        unitSqmMonthly: '元/㎡/月',
        unitSqmDaily: '元/㎡/天',
        unitSqmYearly: '元/㎡/年',
        unitFixedMonthly: '元/月',
        unitFixedDaily: '元/天',
        increaseSetting: '递增设置',
        noIncrease: '无递增',
        hasIncrease: '有递增',
        increaseMethod: '递增方式',
        increasePercent: '固定比例',
        increaseFixed: '固定金额',
        increaseRate: '递增比例',
        increaseAmount: '递增金额',
        increaseHint: '递增是分段级别系数，后续分段会复利累乘',
        increaseLastHint: '最后一个分段无需设置递增（递增作用于下一分段）',
        calcHint: '计算说明：',
        calcHintContent: '默认按「月租金总价」录入。若选面积单价：折合月租金 = 单价 × 面积 = {rent} × {area}',
        // 其他费用
        otherFees: '其他费用（自动创建的费用项已预填）',
        feeName: '费用名称',
        feeCode: '费用编码',
        feeCalcType: '计费方式',
        feeStartDate: '开始日期',
        feeEndDate: '结束日期',
        feeAmount: '金额/单价',
        feeHasIncrease: '参与递增',
        addFee: '添加',
        selectFeeItems: '选择费用项（可多选）',
        managementFee: '物业管理费',
        promotionFund: '推广费',
        unitSqMonthly: '元/㎡/月',
        unitMonthly: '元/月',
        unitOnce: '一次性',
        unitSalesPercent: '销售比例(%)',
        feeAmountPercent: '比例(%)',
        // 免租期
        freeRentSetting: '免租期设置（本分段内）',
        to: '至',
        waiveFees: '豁免费用项：',
        rent: '租金',
        addFreeRent: '+ 添加免租段',
        // 付款方式
        paymentSetting: '付款方式设置',
        paymentCycle: '付款周期',
        cycleMonthly: '月付',
        cycleQuarterly: '季付',
        cycleSemiAnnual: '半年付',
        cycleYearly: '年付',
        billTiming: '出单时机',
        timingCurrent: '当期',
        timingAdvance1: '提前1个月',
        timingAdvance2: '提前2个月',
        billDay: '出单日期',
        firstMonth: '首月',
        secondMonth: '次月',
        day: '号',
        paymentDays: '付款期限',
        daysWithin: '天内',
        lateFeeEnabled: '滞纳金启用',
        enabled: '启用',
        disabled: '不启用',
        lateFeeRate: '滞纳金规则',
        lateFeeCap: '滞纳金上限',
        graceDays: '宽限期',
        optional: '选填',
        billDayHint: '出单日说明：',
        billDayHintContent: '「当期出单」在费用周期当月的指定日出单（如4月费用在4月25日出单）；「提前出单」在费用周期前一个月的指定日出单（如4月费用在3月25日出单）；「次期出单」在费用周期后一个月的指定日出单（如4月费用在5月25日出单）。出单日期选"月末"时自动取当月最后一天',
        // 操作
        noPeriods: '暂无分段配置',
        noPeriodsHint: '点击上方按钮自动拆分或手动添加分段',
        selectContractDateFirst: '请先选择合同起止日期',
        splitSuccess: '分段拆分成功',
        copySuccess: '分段复制成功',
        deleteConfirm: '确定要删除该分段吗？',
        validateNoPeriods: '请先配置合同分段',
        validatePeriodName: '分段名称不能为空',
        validatePeriodDates: '请设置分段的起止日期',
        validateRentCalcType: '请选择租金计算方式',
        validateStandardRent: '请填写标准租金',
        validatePaymentCycle: '请选择付款周期',
        validateBillTiming: '请选择出单时机',
        validatePaymentDays: '请填写付款天数',
        validatePeriodFailed: '第{index}个分段存在未填写的必填项',
        syncFirstPeriod: '同步首段',
        syncFirstPeriodConfirm: '确定将第一分段的设置同步到其他所有分段？（仅时间和名称保持不变）',
        syncSuccess: '已将首段设置同步到其他分段',
      },

      // ==================== 月度费用分解 monthlyFee ====================
      monthlyFee: {
        title: '月度费用分解',
        tipTitle: '操作说明：',
        tipContent: '点击「生成分解表」根据分段配置自动生成月度费用分解，支持按天折算非整月、标记免租期、计算递增。',
        summaryHint: '共 {months} 期，合计 {amount} 元',
        generate: '生成分解表',
        regenerate: '重新生成',
        exportExcel: '导出Excel',
        yearMonth: '月份',
        periodNum: '期数',
        dateRange: '时间段',
        billDate: '出单日',
        rent: '租金',
        managementFee: '物业费',
        promotionFund: '推广费',
        deposit: '保证金',
        totalAmount: '合计',
        remark: '备注',
        freeTag: '免',
        nonFullMonth: '非整月',
        hasFreePeriod: '免租期',
        freeLegend: '免租期费用',
        increaseLegend: '递增月份',
        commissionSettled: '已结算',
        commissionPending: '待销售数据',
        commissionLegend: '扣点租金已按销售数据结算',
        recalculateCommission: '重算扣点',
        recalculateSuccess: '扣点租金重算成功，更新{count}条',
        nonFullMonthLegend: '非整月按天折算',
        noData: '暂无月度费用分解',
        noDataHint: '请先配置分段，然后点击「生成分解表」',
        noContractPeriod: '请先设置合同期限',
        generateSuccess: '月度费用分解生成成功',
        generateFailed: '生成失败',
        exportSuccess: '导出成功',
        exportFailed: '导出失败',
        exportNeedSave: '请先保存合同后再导出',
        total: '合计',
        tabTitle: '月度分解',
        // 费用录入相关
        addFee: '费用录入',
        batchAddFee: '批量录入',
        importFee: '批量导入',
        downloadTemplate: '下载模板',
        feeItem: '费用项目',
        feeType: '费用类型',
        feeTypeNormal: '正常',
        feeTypeAdjust: '调整',
        feeTypeReduce: '减免',
        feeTypeSupplement: '补录',
        feeSource: '费用来源',
        feeSourceContract: '合同生成',
        feeSourceManual: '手动录入',
        generateConfirm: '确认生成月度费用分解表？',
        regenerateConfirm: '重新生成将覆盖现有数据，确认继续？',
        invalidAmount: '请输入有效的金额',
        manualModified: '已手动修改',
        noPeriodsWarning: '请先配置合同分段',
        // 费用录入表单
        inputAmount: '费用金额',
        inputAmountPlaceholder: '正数=增收，负数=减免',
        billDateLabel: '出单日期',
        dueDateLabel: '应付截止日',
        saveAndClose: '保存并关闭',
        saveAndGenerate: '保存并生成账单',
        addFeeSuccess: '费用录入成功',
        addFeeFailed: '费用录入失败',
        // 批量录入
        selectContracts: '选择合同/商户',
        filterByFloor: '按楼层筛选',
        filterByBusinessType: '按业态筛选',
        searchMerchant: '搜索商户',
        selectedContracts: '已选择 {count} 个合同',
        amountMode: '金额模式',
        amountModeFixed: '统一金额',
        amountModeRatio: '按比例',
        amountModeArea: '按面积',
        amountModeFixedPlaceholder: '每户统一金额（负数表示减免）',
        amountModeRatioPlaceholder: '按当前租金比例（如：-10表示减免10%）',
        amountModeAreaPlaceholder: '每平米金额（负数表示减免）',
        batchPreview: '将为 {count} 个合同录入费用，合计金额：{amount} 元',
        batchAddSuccess: '批量录入成功',
        batchAddFailed: '批量录入失败',
        // Excel导入
        importStep1: '下载模板',
        importStep2: '填写数据',
        importStep3: '上传导入',
        importStep4: '校验结果',
        selectFile: '选择文件',
        validating: '正在校验...',
        importResult: '导入结果',
        validRows: '成功',
        invalidRows: '失败',
        viewErrors: '查看错误',
        confirmImport: '确认导入',
        importSuccess: '导入成功',
        importFailed: '导入失败',
        importProgress: '成功: {success}条, 失败: {fail}条',
        generateBillOnImport: '导入后立即生成账单',
        // 表格列
        calcType: '计费方式',
        originalAmount: '原金额',
        actualAmount: '实际应收',
        isFree: '免租',
        increase: '递增',
        days: '天数',
        // 汇总卡片
        totalOriginal: '应收总额',
      },

      // ==================== 续签与变更 renewal/amendment ====================
      // 合同类型
      contractType: '合同类型',
      typeNew: '新签',
      typeRenewal: '续签',
      typeAmendment: '变更',
      contractVersion: '版本',
      // 续签
      renew: '续签',
      renewContract: '发起续签',
      renewConfirm: '确定要基于该合同发起续签吗？将创建一份新的续签合同草稿。',
      renewSuccess: '续签合同草稿已创建',
      renewFailed: '续签失败',
      renewalCompare: '续签对比',
      renewalOriginal: '原合同',
      renewalOriginalValue: '原合同',
      renewalNewValue: '续签合同',
      compareField: '条款',
      compareChange: '变化',
      expandCompare: '展开对比',
      collapseCompare: '收起对比',
      compareAnalysis: '对比分析',
      compareHint: '点击右侧按钮加载与原合同的对比分析',
      originalContract: '原合同',
      rentInfo: '租金信息',
      periodInfo: '分段信息',
      periodEdit: '分段编辑',
      renewalContract: '续签合同',
      changeRate: '变化',
      noChange: '--',
      // 结构化对比区域
      feeImpactTitle: '费用影响分析',
      termChangesTitle: '合同条款变化',
      otherChangesTitle: '其他信息变化',
      fieldLabel: '项目',
      oldValueLabel: '原值',
      newValueLabel: '新值',
      oldTotal: '原合同期总额',
      newTotal: '新合同期总额',
      impact: '差异',
      noFeeChanges: '费用无变化',
      noTermChanges: '条款无变化',
      noOtherChanges: '其他信息无变化',
      totalIncrease: '增加',
      totalDecrease: '减少',
      perUnit: '单价',
      contractTotal: '合同期总额',
      // 变更
      amend: '变更',
      amendment: '合同变更',
      createAmendment: '发起变更',
      createAmendmentConfirm: '确定要对该合同发起变更申请吗？',
      createAmendmentSuccess: '变更申请已创建',
      amendmentNo: '变更编号',
      amendmentType: '变更类型',
      amendmentTypeRent: '租金调整',
      amendmentTypeRate: '扣率调整',
      amendmentTypeTerm: '租期变更',
      amendmentTypeFee: '费用调整',
      amendmentTypeComprehensive: '综合变更',
      canOnlyExtend: '变更模式下只能延长结束日期',
      amendmentReason: '变更原因',
      amendmentReasonPlaceholder: '请输入变更原因',
      effectiveDate: '生效日期',
      effectiveDateRequired: '请选择生效日期',
      amendmentStatus: '变更状态',
      amendmentStatusDraft: '草稿',
      amendmentStatusPending: '待审批',
      amendmentStatusApproved: '已通过',
      amendmentStatusRejected: '已驳回',
      originalValue: '原值',
      newValue: '新值',
      fieldChanged: '已修改',
      saveDraft: '保存草稿',
      submitAmendment: '提交审批',
      submitAmendmentConfirm: '确定要提交该变更申请进行审批吗？',
      submitAmendmentSuccess: '变更申请已提交审批',
      deleteAmendmentConfirm: '确定要删除该变更草稿吗？',
      deleteAmendmentSuccess: '变更草稿已删除',
      updateAmendmentSuccess: '变更申请已保存',
      amendmentFields: '变更字段',
      amendmentContent: '变更内容',
      changeSummary: '变更摘要',
      amendmentApplied: '变更已生效',
      hasActiveAmendment: '该合同已有进行中的变更申请',
      // 历史版本
      history: '历史版本',
      contractHistory: '合同历史',
      versionTimeline: '版本时间线',
      actionInitial: '初始存档',
      actionAmendment: '变更存档',
      actionRenewal: '续签存档',
      viewSnapshot: '查看快照',
      compare: '对比',
      snapshotDetail: '历史快照',
      versionCompare: '版本对比',
      currentVersion: '当前版本',
      historyVersion: '历史版本',
      noHistory: '暂无历史版本',
      // 合同链路
      contractChain: '合同链路',
      currentContract: '当前',
      // 状态 - 归档
      statusArchived: '已归档',
    },

    // ==================== 收付计划 paymentPlan ====================
    paymentPlan: {
      title: '收付计划',
      totalPlan: '计划数',
      totalAmount: '计划总额',
      paidAmount: '已收金额',
      generatePlan: '生成计划',
      updateOverdue: '更新逾期',
      overdueAlert: '有 {count} 笔逾期未付款',
      showAll: '显示全部',
      showOverdue: '仅显示逾期',
      periodNum: '期数',
      billDate: '出单日',
      dueDate: '截止日',
      periodStart: '费用周期',
      periodEnd: '周期结束',
      periodRange: '费用周期',
      planAmount: '计划金额',
      paidAmountLabel: '已收金额',
      lateFee: '滞纳金',
      lateFeeAmount: '滞纳金',
      overdueDays: '逾期天数',
      days: '天',
      registerPay: '登记收款',
      registerPayTitle: '收款登记',
      unpaidAmount: '未收金额',
      inputPayAmount: '实收金额',
      inputLateFee: '实收滞纳金',
      generateConfirm: '生成收付计划将覆盖已有数据，是否继续？',
      generateSuccess: '收付计划生成成功',
      generateFailed: '生成失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      paySuccess: '收款登记成功',
      payFailed: '收款失败',
      statusPending: '计划',
      statusPaid: '已付',
      statusPartial: '部分付',
      statusOverdue: '逾期',
      statusPendingDesc: '计划中',
      statusPaidDesc: '已付清',
      statusOverdueDesc: '已逾期',
      emptyText: '暂无收付计划',
      pleaseSaveContract: '请先保存合同',
      // 新增字段
      regenerateConfirm: '重新生成将覆盖现有计划数据，确认继续？',
      hasPaidWarning: '存在已收款的账单，不能重新生成',
      noMonthlyFeeWarning: '请先生成月度费用分解',
      refreshOverdue: '刷新逾期状态',
      overdueUpdated: '逾期状态已更新',
      generateManualPlan: '手动生成账单',
      generateManualSuccess: '账单生成成功',
      generateManualFailed: '账单生成失败',
      selectFeeToGenerate: '请选择要生成账单的费用',
      // 收款弹窗
      payRemark: '收款备注',
      payRemarkPlaceholder: '请输入收款备注',
      payAmountExceed: '收款金额超出应付金额，是否确认为预收？',
      payConfirm: '确认收款',
    },

    // ==================== 账单管理 billing ====================
    billing: {
      title: '账单管理',
      // 表格列
      billNo: '账单编号',
      contractNo: '合同编号',
      merchantName: '商户名称',
      brandName: '品牌',
      assetName: '铺位',
      planAmount: '应收金额',
      paidAmount: '已收金额',
      lateFee: '滞纳金',
      overdueDays: '逾期天数',
      dueDate: '应收截止日',
      periodRange: '费用周期',
      periodNum: '期数',
      status: '状态',
      billStatus: '账单状态',
      operation: '操作',
      // 汇总卡片
      totalPlan: '应收总额',
      totalPaid: '已收金额',
      remaining: '待收余额',
      totalOverdue: '逾期金额',
      overdueCount: '逾期笔数',
      totalLateFee: '滞纳金合计',
      // 搜索筛选
      searchPlaceholder: '合同编号/商户名称',
      dateRangeLabel: '截止日期',
      // 操作
      exportBill: '导出账单',
      printBill: '打印账单',
      refreshOverdue: '刷新逾期',
      // 逾期汇总
      topOverdueContracts: '逾期排名',
      overdueAmount: '逾期金额',
      // 状态
      statusPlan: '计划',
      statusUnpaid: '未收款',
      statusPending: '待付',
      statusPaid: '已付',
      statusPartial: '部分付',
      statusOverdue: '逾期',
      statusPendingDesc: '待付款',
      statusPaidDesc: '已付清',
      statusOverdueDesc: '已逾期',
      // 账单类型筛选
      billType: '账单类型',
      typeBill: '正式账单',
      typePlan: '计划记录',
      // 生成账单
      generateBill: '生成账单',
      generateBillConfirm: '确认将此计划记录转换为正式账单？',
      generateBillSuccess: '账单生成成功',
      generateBillFailed: '账单生成失败',
      planTag: '计划记录',
      // 详情
      viewDetail: '查看',
      billDetail: '账单详情',
      basicInfoSection: '账单基本信息',
      monthlyFeeSection: '关联费用明细',
      feeSource: '账单来源',
      feeSourceContract: '合同生成',
      feeSourceManual: '手动录入',
      feeSourcePlan: '计划转换',
      noFeeData: '暂无关联费用',
      // 费用调整
      adjustFee: '费用调整',
      adjustTitle: '账单费用调整',
      adjustType: '调整类型',
      adjustIncrease: '增加',
      adjustDecrease: '减少',
      adjustAmount: '调整金额',
      adjustReason: '调整原因',
      adjustReasonPlaceholder: '请输入调整原因',
      adjustAmountMin: '调整金额必须大于0',
      adjustSuccess: '费用调整成功',
      adjustFailed: '费用调整失败',
      adjustWarning: '调减后应付将小于已付，请确认',
      currentPlanAmount: '当前应付',
      currentUnpaid: '待付余额',
      afterAdjustAmount: '调整后应付',
      // 费用录入
      addFee: '录入费用',
      addFeeTitle: '录入临时费用',
      addFeeSuccess: '费用录入成功',
      addFeeFailed: '费用录入失败',
      targetBill: '目标账单',
      feeItemLabel: '费用项目',
      feeAmount: '金额',
      // 更多操作
      more: '更多',
      printSingle: '打印',
      printBillTitle: '账单打印',
      // 费用表格列
      feeItemName: '费用项目',
      feeType: '费用类型',
      originalAmount: '原金额',
      actualAmount: '实际金额',
      yearMonth: '年月',
      isFreeLabel: '免租',
      // 重新生成
      regenerateBill: '重新生成',
      regenerateConfirm: '确认重新生成此账单？将重新汇总最新的关联费用',
      regenerateSuccess: '账单重新生成成功',
      regenerateFailed: '重新生成失败',
      // 确认账单
      confirmBill: '确认账单',
      confirmBillAction: '确认',
      confirmBillTip: '确认后账单将锁定，不可再修改费用',
      confirmBillSuccess: '账单已确认',
      confirmBillFailed: '确认失败',
      // 审批流程
      submitApproval: '提交审批',
      submitApprovalConfirm: '确定要提交此账单进行两级审批（营运→财务）吗？',
      submitApprovalSuccess: '账单已提交审批',
      submitApprovalFailed: '提交审批失败',
      viewApprovalProgress: '查看审批进度',
      noApprovalProgress: '暂无审批进度信息',
      approvalProgress: '审批进度',
      approvalRecords: '审批记录',
      noApprovalRecords: '暂无审批记录',
      operator: '审批人',
      comment: '审批意见',
      stepSubmit: '提交',
      stepOperationApproval: '营运审批',
      stepFinanceApproval: '财务审批',
      stepComplete: '完成',
      // REVIEWING 状态
      statusReviewing: '审批中',
      // CONFIRMED 状态
      statusConfirmed: '已确认',
      statusMerchantConfirmed: '商户已确认',
      // 费用表格列（发票选择用）
      feeName: '费用项目',
      amount: '金额',
      // 手动生成账单
      manualGenerate: '手动生成账单',
      manualGenerateTitle: '手动生成账单',
      selectContract: '选择合同',
      searchContractPlaceholder: '输入合同编号或商户名搜索',
      planListTitle: '收付计划列表',
      noPlanData: '该合同暂无收付计划',
      noSelectablePlan: '没有可操作的计划记录',
      selectedCount: '已选 {count} 期',
      selectedTotal: '总金额',
      billConfirmed: '已确认',
      billPaid: '已付清',
      canRegenerate: '可重新生成',
      pendingGenerate: '待生成',
      manualGenerateConfirm: '确认为选中的 {count} 期生成（或重新生成）正式账单？',
      manualGenerateSuccess: '成功处理 {count} 张账单',
      manualGenerateFailed: '批量生成账单失败',
    },

    // ==================== 费用录入 feeEntry ====================
    feeEntry: {
      title: '费用录入',
      addFee: '新增费用',
      excelImport: '导入Excel',
      linkToBill: '导入账单',
      generateBill: '生成账单',
      batchDelete: '批量删除',
      contractNo: '合同编号',
      merchantName: '商户名称',
      yearMonth: '年月',
      feeSource: '费用来源',
      feeSourceManual: '手动录入',
      feeSourceImported: 'Excel导入',
      feeSourceRenovation: '装修费用',
      feeItemName: '费用项目',
      feeType: '费用类型',
      amount: '金额',
      linkedBill: '关联账单',
      linked: '已关联',
      unlinked: '未关联',
      createTime: '创建时间',
      operation: '操作',
      // 录入弹窗
      addTitle: '新增费用',
      editTitle: '编辑费用',
      selectContract: '选择合同',
      searchContractPlaceholder: '输入合同号或商户名搜索',
      selectFeeItems: '费用项目',
      chargeMonth: '计入月份',
      chargeMonthPlaceholder: '选择费用计入的月份',
      amountDetail: '金额明细',
      billDate: '出单日',
      dueDate: '截止日',
      saveSuccess: '费用保存成功',
      saveFailed: '费用保存失败',
      // 导入账单弹窗
      linkTitle: '导入账单',
      linkTip: '将 {count} 条费用导入到以下账单',
      noAvailableBill: '该合同下没有可导入的待确认账单',
      createNewBill: '生成新账单',
      linkSuccess: '费用已导入账单',
      linkFailed: '导入失败',
      generateSuccess: '独立账单生成成功',
      generateFailed: '生成失败',
      // 删除
      deleteConfirm: '确定删除选中的 {count} 条费用？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      // 校验
      selectFeeFirst: '请先选择费用记录',
      onlyUnlinkedCanOperate: '只能操作未关联账单的费用',
      feesMustSameContract: '选中的费用必须属于同一合同',
      // 状态
      statusDraft: '待确认',
      statusConfirmed: '已确认',
      statusPending: '已出账',
      statusPartial: '部分付款',
      statusPaid: '已付款',
      statusOverdue: '已逾期',
      statusFilter: '状态',
      // 审核
      confirmFee: '审核确认',
      confirmFeeConfirm: '确认审核选中的 {count} 条费用？确认后不可删除。',
      confirmFeeSuccess: '已确认 {count} 条费用',
      confirmFeeFailed: '审核确认失败',
      onlyDraftCanDelete: '已确认的费用不能删除',
      onlyConfirmedCanOperate: '只有已确认的费用才能导入账单或生成账单',
      // 退还
      refundable: '可退还',
      nonRefundable: '不可退还',
      refundStatusNone: '未退还',
      refundStatusPending: '待退还',
      refundStatusRefunded: '已退还',
      refundFee: '退还',
      refundAmount: '退还金额',
      refundRemark: '退还备注',
      refundConfirm: '确认退还该笔费用？',
      refundSuccess: '退还成功',
      refundFailed: '退还失败',
      isRefundable: '是否可退还',
    },

    // ==================== 洽谈管理 negotiation ====================
    negotiation: {
      title: '洽谈管理',
      // 洽谈方式
      methodVisit: '现场拜访',
      methodPhone: '电话沟通',
      methodOnline: '线上沟通',
      methodCall: '电话',
      methodFace: '面谈',
      methodWechat: '微信',
      methodEmail: '邮件',
      methodOther: '其他',
      // 洽谈结果
      resultContinue: '继续跟进',
      resultNegotiating: '洽谈中',
      resultSigned: '达成签约',
      resultTerminated: '终止',
      resultVisited: '已拜访',
      resultInterested: '有意向',
      resultNoInterest: '无意向',
      resultPending: '待跟进',
      resultIntention: '有意向',
      resultNoIntention: '无意向',
      resultReached: '已达成',
      resultNone: '未达成',
      resultPreliminary: '初步达成',
      resultFull: '完全达成',
      // 标签
      method: '洽谈方式',
      date: '洽谈日期',
      location: '洽谈地点',
      responsible: '洽谈负责人',
      participants: '参与人员',
      content: '洽谈内容',
      merchantDemand: '商户需求',
      ourProposal: '我方提议',
      nextPlan: '下一步计划',
      result: '洽谈结果',
      successRate: '成功概率',
      followUpDate: '跟进日期',
      nextFollowUp: '下次跟进',
      // 表单
      addRecord: '新增洽谈记录',
      recordDetail: '洽谈记录详情',
      currentShop: '当前铺位',
      selectMerchant: '请选择商户',
      selectDate: '选择日期',
      contentPlaceholder: '请输入洽谈内容',
      remarkPlaceholder: '请输入备注',
      // 验证
      merchantRequired: '请选择商户',
      methodRequired: '请选择洽谈方式',
      dateRequired: '请选择洽谈日期',
      contentRequired: '请输入洽谈内容',
      // 成功消息
      addSuccess: '新增洽谈记录成功',
      addFailed: '新增洽谈记录失败',
      loadDetailFailed: '加载洽谈记录详情失败',
      // 区块标题
      sectionBasic: '基本信息',
      sectionContent: '洽谈内容',
      sectionResult: '洽谈结果',
      // 商户面板中
      unknownMerchant: '未知商户',
      noRecords: '暂无洽谈记录',
      // 弹窗标题
      addNegotiation: '新增洽谈记录',
      editNegotiation: '修改洽谈记录',
      negotiationDetail: '洽谈详情',
      // 铺位
      shop: '铺位',
      shopPlaceholder: '请选择铺位',
      // 表单标签
      merchantId: '商户',
      merchantIdPlaceholder: '请选择商户',
      locationPlaceholder: '请输入洽谈地点',
      responsiblePlaceholder: '请输入洽谈负责人',
      participantsPlaceholder: '请输入参与人员',
      merchantDemandPlaceholder: '请输入商户需求',
      ourProposalPlaceholder: '请输入我方提议',
      nextPlanPlaceholder: '请输入下一步计划',
      // 确认
      deleteConfirm: '是否确认删除该洽谈记录？',
      batchDeleteConfirm: '是否确认删除选中的洽谈记录？',
      // 验证
      merchantRequired: '请选择商户',
      merchantIdRequired: '请选择商户',
      brand: '品牌',
      createIntention: '创建意向',
      batchCreateSuccess: '成功创建 {count} 条洽谈记录',
      addFailed: '创建洽谈记录失败',
      // 洽谈轮次
      round: '洽谈轮次',
      roundFirst: '初次',
      roundSecond: '二次',
      roundFinal: '最终',
      roundPlaceholder: '请选择洽谈轮次',
      // 地点类型
      locationType: '地点类型',
      locationTypeOnSite: '现场',
      locationTypeMeetingRoom: '会议室',
      locationTypeOther: '其他',
      locationTypePlaceholder: '请选择地点类型',
      // 带看信息
      sectionViewing: '带看信息',
      hasViewing: '本次洽谈包含带看',
      viewingShops: '带看铺位',
      viewingShopsPlaceholder: '请选择带看铺位',
      viewingResult: '带看结果',
      viewingResultVeryInterested: '非常有意向',
      viewingResultGeneral: '一般',
      viewingResultNotInterested: '无意向',
      viewingResultPlaceholder: '请选择带看结果',
      viewingPerson: '带看人',
      viewingPersonPlaceholder: '请输入带看人',
      viewingCount: '带看次数',
      siteEvaluation: '商户现场评价',
      siteEvaluationPlaceholder: '请输入商户对位置、面积、工程条件等的评价',
      viewingRemark: '带看备注',
      viewingRemarkPlaceholder: '请输入带看备注',
      // 洽谈核心内容
      sectionCore: '洽谈核心内容',
      ourOffer: '我方报价',
      ourOfferPlaceholder: '请输入我方报价（租金/物业费/保底/扣率/免租期/合同期等）',
      disputes: '分歧点',
      disputesPlaceholder: '请输入双方主要分歧',
      agreementStatus: '达成情况',
      agreementNone: '未达成',
      agreementPreliminary: '初步达成',
      agreementFull: '完全达成',
      agreementPending: '待确认',
      agreementAgreed: '已达成',
      agreementStatusPlaceholder: '请选择达成情况',
      // 结果与后续
      sectionFollowUp: '结果与后续',
      nextAction: '下一步动作',
      nextActionPlaceholder: '请输入下一步动作',
    },

    // ==================== 意向管理 intention ====================
    intention: {
      title: '意向管理',
      // 状态
      statusActive: '有效',
      statusExpired: '已过期',
      statusCancelled: '已取消',
      statusConverted: '已转签约',
      // 标签
      shop: '铺位',
      merchant: '商户',
      brand: '品牌',
      signingCompany: '收费主体',
      proposedRent: '拟议租金',
      rentCalculation: '计租方式',
      proposedArea: '拟议面积',
      managementFee: '物业管理费',
      commissionRate: '扣点比例',
      guaranteedAmount: '保底金额',
      contractPeriod: '合同期限',
      freePeriod: '免租期',
      annualIncrease: '年递增率',
      deposit: '保证金',
      paymentMethod: '缴费方式',
      intentionFeeStatus: '意向金状态',
      intentionFeePaid: '已缴意向金',
      businessPlan: '经营计划',
      specialRequirements: '特殊要求',
      suggestedRent: '建议租金',
      suggestedArea: '建议面积',
      // 计租方式
      rentFixed: '固定租金',
      rentCommission: '扣点',
      rentGuaranteed: '保底取高',
      // 付款方式
      payMonthly: '月付',
      payQuarterly: '季付',
      payYearly: '年付',
      // 意向金状态
      feeNotPaid: '未缴纳',
      feePaid: '已缴纳',
      feeRefunded: '已退还',
      // 表单
      createIntention: '创建招商意向',
      sectionSelectShop: '选择铺位',
      sectionMerchantInfo: '商户信息',
      sectionLeaseTerms: '租赁条款',
      sectionContractPeriod: '合同期限',
      sectionFeeInfo: '费用信息',
      sectionOther: '其他',
      // 铺位状态标签
      shopRented: '已入驻',
      shopSigned: '已签约',
      shopIntention: '意向中',
      shopNegotiating: '洽谈中',
      shopReserved: '预留',
      shopMaintenance: '维修中',
      shopVacant: '待招商',
      // 多选提示
      selectedShops: '已选择 {count} 个铺位，将为每个铺位分别创建意向记录',
      selectShopPlaceholder: '请选择铺位（支持多选）',
      shopPlaceholder: '请选择铺位',
      // 占位符
      merchantPlaceholder: '请选择商户',
      brandPlaceholder: '请选择品牌',
      companyPlaceholder: '请输入收费主体名称',
      rentPlaceholder: '元/㎡/月',
      areaPlaceholder: '㎡',
      percentPlaceholder: '%',
      amountPlaceholder: '元/月',
      monthPlaceholder: '月',
      yuanPlaceholder: '元',
      planPlaceholder: '请输入经营计划',
      requirementsPlaceholder: '请输入特殊要求',
      // 验证
      shopRequired: '请至少选择一个铺位',
      merchantRequired: '请选择商户',
      rentRequired: '请输入拟议租金',
      startDateRequired: '请选择开始日期',
      endDateRequired: '请选择结束日期',
      // 成功消息
      batchCreateSuccess: '成功创建 {count} 条意向',
      createSuccess: '创建意向成功',
      createFailed: '创建意向失败',
      createPartialFailed: '{count} 条意向创建失败',
      cancelSuccess: '意向已取消',
      cancelFailed: '取消意向失败',
      noRecords: '暂无意向记录',
      // 操作
      cancelIntention: '取消',
      createFormalPlacement: '创建正式落位',
      convertToContract: '转化签约',
      cancelIntentionConfirm: '确定要取消该意向吗？此操作不可恢复。',
      cancelIntentionTitle: '取消意向',
      confirmCancel: '确定取消',
      // Tab标题
      tabBasic: '基本信息',
      tabLeaseTerms: '租赁条款',
      tabNegotiation: '洽谈记录',
      tabConfirmation: '意向确认',
      tabDeposit: '意向金',
      // 工作台统计
      workbenchTitle: '洽谈与意向工作台',
      statsPendingFollow: '待跟进',
      statsConfirming: '确认中',
      statsDepositPaid: '已收款',
      statsReadyToLand: '可落位',
      // 洽谈记录时间线
      negotiationTimeline: '洽谈记录',
      noNegotiationRecord: '暂无洽谈记录',
      viewAllNegotiations: '查看全部',
      addNegotiationRecord: '添加洽谈记录',
      // 意向确认
      confirmationStatus: '确认状态',
      confirmationDate: '确认日期',
      confirmIntention: '确认意向',
      submitConfirm: '提交确认',
      approveConfirm: '审核通过',
      rejectConfirm: '驳回',
      submitConfirmSuccess: '已提交确认审核',
      approveConfirmSuccess: '审核通过',
      rejectConfirmSuccess: '已驳回',
      submitConfirmMsg: '确定要提交该意向进行确认审核吗？',
      approveConfirmMsg: '确定要审核通过该意向确认吗？',
      rejectConfirmMsg: '请输入驳回原因',
      rejectConfirmTitle: '驳回意向确认',
      // 确认状态选项
      confirmStatusDraft: '草稿',
      confirmStatusPending: '审核中',
      confirmStatusConfirmed: '已确认',
      confirmStatusRejected: '已驳回',
      confirmStatusVoided: '已作废',
      // 意向金
      depositAmount: '意向金金额',
      depositPaid: '已缴金额',
      depositStatus: '意向金状态',
      payDeposit: '缴纳意向金',
      refundDeposit: '退还意向金',
      // 详情抽屉
      detailDrawer: '意向详情',
      printIntention: '打印意向单',
      noCustomTemplate: '未配置打印模板，请在【系统管理 > 打印模板管理】中配置意向单模板',
      // 筛选
      filterShop: '铺位',
      filterBusinessType: '业态',
      filterBrand: '品牌',
      filterAllStatus: '全部状态',
      businessTypeAll: '全部业态',
      brandAll: '全部品牌',
      shopAll: '全部铺位',
      // 列表标签
      intentionNo: '意向编号',
      intentionDate: '意向日期',
      expiryDate: '到期日期',
      leasePeriod: '租赁周期',
      freePeriodMonths: '免租期(月)',
      assetType: '资产类型',
      // 弹窗标题
      addIntention: '添加意向',
      editIntention: '修改意向',
      intentionDetail: '意向详情',
      // 确认
      deleteConfirm: '是否确认删除该意向？',
      batchDeleteConfirm: '是否确认删除选中的意向？',
      convertConfirm: '是否确认将该意向转化为签约合同？',
      convertTitle: '确认转化',
      convertSuccess: '转化成功',
      // 搜索
      keyword: '关键字',
      keywordPlaceholder: '请输入意向编号/商户名/品牌名',
      dateRange: '意向日期',
      dateRangeTo: '至',
      // 表单
      proposedStartDate: '拟起始日',
      proposedEndDate: '拟结束日',
      startDatePlaceholder: '请选择起始日期',
      endDatePlaceholder: '请选择结束日期',
      intentionDatePlaceholder: '请选择意向日期',
      expiryDatePlaceholder: '请选择到期日期',
      // 验证
      brandRequired: '请选择品牌',
      intentionDateRequired: '请选择意向日期',
      proposedRentRequired: '请输入建议租金',
      // 表格列标签
      merchantName: '商户名称',
      brandName: '品牌名称',
      shopName: '资产名称',
      statusLabel: '状态',
      signCompany: '收费主体',
      signCompanyPlaceholder: '请输入收费主体',
      rentFreePeriod: '免租期',
      annualIncreaseRate: '年递增率',
      specialReqs: '特殊要求',
      businessPlanPlaceholder: '请输入经营计划',
      specialReqsPlaceholder: '请输入特殊要求',
      intentionDepositStatus: '意向金状态',
      // 意向金子模块
      deposit: {
        feeConfig: '费用配置',
        feeName: '费用名称',
        feeCode: '费用编码',
        feeItem: '费用项目',
        selectFeeItem: '请选择费用项',
        amount: '金额',
        remark: '备注',
        totalAmount: '费用合计',
        paymentRecords: '收款记录',
        receivePayment: '录入收款',
        recordNo: '记录编号',
        paymentMethod: '付款方式',
        paymentTime: '收款时间',
        payee: '收款人',
        recordStatus: '状态',
        recordDetail: '收款详情',
        // 付款方式
        cash: '现金',
        bankTransfer: '银行转账',
        alipay: '支付宝',
        wechat: '微信',
        check: '支票',
        // 收款状态
        statusPending: '待收款',
        statusReceived: '已收款',
        statusDeducted: '已抵扣',
        statusRefundPending: '退款中',
        statusRefunded: '已退款',
        // 统计
        receivedAmount: '已收款',
        availableDeduct: '可抵扣',
        // 操作
        deduct: '抵扣',
        refund: '退款',
        refundApplied: '已申请退款',
        // 弹窗字段
        deductAmount: '抵扣金额',
        availableAmount: '可用金额',
        refundAmount: '退款金额',
        refundableAmount: '可退金额',
        refundReason: '退款原因',
        deductedAmount: '已抵扣金额',
        effectiveTime: '生效时间',
        // 系统配置相关
        systemConfig: '系统配置',
        feeConfigTip: '费用项目由系统统一配置，如需修改请前往「系统管理 > 费用项目管理」',
        calcType: '计费方式',
        calcTypeSqMonthly: '元/㎡/月',
        calcTypeFixedMonthly: '元/月',
        calcTypeFixedOnce: '一次性',
        calcTypePercent: '按比例',
        defaultValue: '默认值',
      },
    },

    // ==================== 计划管理 plan ====================
    plan: {
      title: '计划管理',
      planName: '计划名称',
      planType: '计划类型',
      targetPeriod: '目标周期',
      targetRentRate: '目标出租率',
      targetIncome: '目标收入',
      targetTotalIncome: '目标总收入',
      responsible: '负责人',
      participants: '参与人',
      businessTypeTargets: '业态目标',
      businessTypeTargetsPlaceholder: '业态占比目标，如：餐饮30%，零售40%，娱乐20%，其他10%',
      keyTasks: '重点任务',
      planDescription: '计划描述',
      approvalComments: '审批意见',
      approver: '审批人',
      approvalDate: '审批时间',
      approvalStatus: '审批状态',
      startDate: '开始日期',
      endDate: '结束日期',
      // 类型
      typeAnnual: '年度计划',
      typeQuarter: '季度计划',
      typeMonthly: '月度计划',
      // 审批状态
      statusDraft: '草稿',
      statusPending: '待审批',
      statusApproved: '已批准',
      statusRejected: '已拒绝',
      // 弹窗标题
      addPlan: '新增招商计划',
      editPlan: '编辑招商计划',
      planDetail: '招商计划详情',
      // 验证
      planNameRequired: '计划名称不能为空',
      planTypeRequired: '计划类型不能为空',
      startDateRequired: '开始日期不能为空',
      endDateRequired: '结束日期不能为空',
      // 确认
      deleteConfirm: '是否确认删除该招商计划？',
    },

    // ==================== 任务管理 task ====================
    task: {
      title: '任务管理',
      taskName: '任务名称',
      taskType: '任务类型',
      taskStatus: '任务状态',
      assignedTo: '负责人',
      deadline: '截止日期',
      progress: '进度',
      targetIncome: '目标收入',
      targetMerchantCount: '目标商户数',
      targetAssetType: '目标资产类型',
      targetAssetTypePlaceholder: '如：商铺/办公/车位',
      taskDescription: '任务描述',
      taskRequirements: '任务要求',
      relatedPlan: '关联计划',
      relatedPlanPlaceholder: '请选择关联计划',
      completionDate: '完成时间',
      // 类型
      typeMerchant: '招商',
      typeNegotiation: '洽谈',
      typeContract: '签约',
      typeOther: '其他',
      // 状态
      statusPending: '待开始',
      statusInProgress: '进行中',
      statusCompleted: '已完成',
      statusCancelled: '已取消',
      statusOverdue: '已逾期',
      // 完成
      completionResult: '实际完成情况',
      // 弹窗标题
      addTask: '新增招商任务',
      editTask: '编辑招商任务',
      taskDetail: '招商任务详情',
      completeTaskTitle: '完成任务',
      // 操作
      startExecution: '开始执行',
      completeTask: '完成任务',
      cancelTask: '取消任务',
      confirmComplete: '确认完成',
      // 验证
      taskNameRequired: '任务名称不能为空',
      taskTypeRequired: '任务类型不能为空',
      deadlineRequired: '截止日期不能为空',
      assignedToRequired: '负责人不能为空',
      // 确认
      deleteConfirm: '是否确认删除该任务？',
      cancelConfirm: '是否确认取消该任务？',
      // 成功消息
      taskStarted: '任务已开始',
      taskCompleted: '任务已完成',
      taskCancelled: '任务已取消',
    },

    // ==================== 工作台 workbench ====================
    workbench: {
      title: '招商工作台',
      // 画布
      noAssetData: '暂无资产数据，请选择楼层',
      selectBuilding: '选择楼栋',
      selectFloor: '选择楼层',
      // 工作阶段
      phaseAnalytics: '数据分析',
      phaseProgress: '招商执行',
      // 视图模式
      viewList: '列表',
      viewCanvas: '画布',
      // 工具栏
      filter: '筛选',
      exitFullscreen: '退出',
      fullscreen: '全屏',
      searchAssetName: '搜索资产名称',
      assetType: '资产类型',
      assetTypeShop: '铺位',
      assetTypeOfficeSpace: '写字间',
      assetTypeParking: '车位',
      assetTypeSharedSpace: '共享空间',
      assetTypeWarehouse: '仓库',
      assetTypeAdvertising: '广告位',
      businessTypeFilter: '业态筛选',
      progressFilter: '进度筛选',
      clearFilters: '清空筛选',
      // 业态选项
      businessRetail: '零售',
      businessFood: '餐饮',
      businessEntertainment: '娱乐',
      businessService: '服务',
      businessNone: '未规划',
      // 进度状态选项
      progressEntered: '已入驻',
      progressSigned: '已签约',
      progressActive: '意向中',
      progressNegotiating: '洽谈中',
      progressVacant: '待招商',
      // 面板
      assetDetail: '资产详情',
      businessPlanning: '业态规划',
      // 面板标题
      basicInfo: '基本信息',
      policyInfo: '招商政策',
      contractInfo: '合同信息',
      intentionInfo: '意向信息',
      negotiationRecords: '洽谈记录',
      placementInfo: '正式落位',
      simulatedPlacementInfo: '模拟落位',
      noSimulatedPlacement: '暂无模拟落位记录',
      lifecycle: '招商进度链',
      // 描述标签
      assetCode: '资产编码',
      shopStatus: '资产状态',
      merchantProgress: '招商进度',
      businessTypePlanning: '业态规划',
      selectBusinessType: '选择业态',
      policyName: '政策名称',
      selectPolicy: '请选择招商政策',
      changePolicy: '更换招商政策',
      noPolicy: '暂无关联政策',
      // 铺位状态
      statusRented: '已出租',
      statusAvailable: '空置',
      statusReserved: '预留',
      statusMaintenance: '维修',
      statusOperating: '已开业',
      statusPendingExit: '待退场',
      noContract: '暂无合同',
      // 合同状态
      contractDraft: '草稿',
      contractPending: '待审核',
      contractActive: '生效中',
      contractExpired: '已到期',
      contractTerminated: '已终止',
      // 意向状态
      intentionConverted: '已签约',
      intentionActive: '意向中',
      intentionExpired: '已过期',
      intentionCancelled: '已取消',
      // 按钮
      signContract: '签约',
      convert: '转化',
      createIntention: '创建意向',
      renovation: '装修',
      // 审批
      approvalPending: '有 {count} 个审批进行中',
      approvalInProgress: '审批中',
      // 统计图表
      statisticsTitle: '数据统计',
      chartProgress: '招商进度',
      chartBusinessType: '业态分布',
      chartLeaseRate: '楼层出租率',
      chartArea: '面积统计',
      totalArea: '总面积',
      rentedArea: '已租面积',
      vacantArea: '空置面积',
      leaseRate: '出租率',
      expandCharts: '展开统计图表',
      collapseCharts: '收起统计图表',
      // 图例
      legendTitle: '图例',
      legendTotal: '总计',
      // 右键菜单
      noAvailableActions: '暂无可用操作',
      // 生命周期
      lifecycleCompleted: '已完成',
      lifecycleInProgress: '进行中',
      lifecyclePending: '待开始',
      lifecycleApprovalPending: '审批进行中，请等待审批结果',
      lifecycleCompletionTime: '完成时间：',
      // 成功消息
      policyLinked: '关联政策成功',
      policyLinkFailed: '关联政策失败',
      currentBusinessType: '当前业态',
      changeBusinessType: '更换业态',
      setBusinessTypePlaceholder: '选择业态',
      businessTypeLinked: '设置业态成功',
      businessTypeLinkFailed: '设置业态失败',
      businessTypeSet: '设置业态成功',
      businessTypeCleared: '已清除业态',
      businessTypeFailed: '设置业态失败',
      createIntentionFromNeg: '创建意向',
      // 列表视图列头
      colName: '资产名称',
      colCode: '资产编码',
      colArea: '面积(㎡)',
      colStatus: '资产状态',
      colBusinessType: '业态',
      colMerchant: '商户',
      colBrand: '品牌',
      colProgressStatus: '招商状态',
      // 招商进度
      progressRenovating: '装修中',
      // 铺位档案
      archive: {
        title: '{name}铺位档案',
        openArchive: '铺位档案',
        area: '面积',
        currentStatus: '当前状态',
        totalMerchants: '累计入驻',
        merchantsUnit: '家商户',
        totalVacantDays: '累计空置',
        daysUnit: '天',
        avgLeaseYears: '平均租期',
        yearsUnit: '年',
        remainingDays: '合同剩余',
        timeline: '历史时间轴',
        expiryWarning: '当前合同将于 {days} 天后到期，建议提前安排续约或招商',
        noRecords: '暂无历史记录',
        operating: '经营中',
        vacant: '空置',
        renovating: '装修中',
        reserved: '已预订',
        statusActive: '进行中',
        statusUpcoming: '即将开始',
        eventContract: '合同经营',
        eventVacancy: '空置期',
        eventRenovation: '装修期',
        eventExit: '退场',
        eventIntention: '意向/预订',
        contractNo: '合同编号',
        rentAmount: '月租金',
        monthlySales: '月均销售',
        exitReason: '退场原因',
        month: '月',
      },
    },

    // ==================== 弹窗组件 dialogs ====================
    dialogs: {
      // 签约弹窗
      contractFormTitle: '正式签约 — 从意向创建合同',
      contractFormAlert: '将从当前意向自动结转创建合同草稿，意向中的条款信息将自动填充到合同中。',
      contractDraftCreated: '合同草稿已创建',
      contractDraftSuccess: '合同草稿创建成功',
      contractCreateFailed: '创建合同失败',
      noValidIntention: '未找到有效意向',
      viewContractDetail: '查看合同详情',
      confirmCreateContract: '确认创建合同',
      // 意向转化弹窗
      convertTitle: '意向签约转化',
      convertAlertApproval: '将意向转化为合同。本操作需要审批，提交后将进入审批流程。',
      convertAlertDirect: '确认后将直接执行转化。',
      submitApproval: '提交审批',
      confirmConvert: '确认转化',
      convertApprovalSubmitted: '已提交审批，请等待审批结果',
      convertSuccess: '签约转化成功',
      convertFailed: '操作失败',
      noValidIntentionForConvert: '无有效意向',
      // 商户进场弹窗
      entryTitle: '商户进场',
      entryAlertApproval: '确认商户进场。本操作需要审批，提交后将进入审批流程。',
      entryAlertDirect: '确认后资产状态将变为已出租。',
      entryDate: '进场日期',
      confirmEntry: '确认进场',
      entryApprovalSubmitted: '已提交审批，请等待审批结果',
      entrySuccess: '商户进场成功',
      entryFailed: '操作失败',
      // 商户退场弹窗
      exitTitle: '商户退场',
      exitAlertApproval: '确认商户退场。本操作需要审批，提交后将进入审批流程。',
      exitAlertDirect: '确认后资产状态将变为空置，相关意向将被关闭。',
      exitDate: '退场日期',
      exitReason: '退场原因',
      confirmExit: '确认退场',
      exitDateRequired: '请选择退场日期',
      exitReasonRequired: '请选择退场原因',
      exitApprovalSubmitted: '已提交审批，请等待审批结果',
      exitSuccess: '商户退场成功',
      exitFailed: '操作失败',
      // 退场原因选项
      exitReasonExpired: '合同到期',
      exitReasonEarlyTermination: '提前退租',
      exitReasonBreach: '违约退场',
      exitReasonNegotiated: '协商退场',
      exitReasonOther: '其他',
      // 政策选择弹窗
      policySelectTitle: '设置招商政策',
      selectPolicy: '选择政策',
      policySelectPlaceholder: '请选择招商政策',
      policyRequired: '请选择招商政策',
      policySetSuccess: '关联政策成功',
      policySetFailed: '设置政策失败',
      // 快速新建商户弹窗
      quickMerchantTitle: '快速新建商户',
      merchantCreated: '商户创建成功',
      merchantCreateFailed: '创建商户失败',
      merchantNameLabel: '商户名称',
      merchantCodeLabel: '商户编码',
      merchantLevelLabel: '商户等级',
      industryLabel: '所属行业',
      contactPersonLabel: '联系人',
      contactPhoneLabel: '联系电话',
      contactEmailLabel: '联系邮箱',
      foundingYearLabel: '成立年份',
      headquartersLabel: '总部地址',
      merchantDescLabel: '商户简介',
      websiteLabel: '官方网站',
      preferredLabel: '优选商户',
      alternativeLabel: '备选商户',
      merchantNamePlaceholder: '请输入商户名称',
      merchantCodePlaceholder: '请输入商户编码',
      contactPersonPlaceholder: '请输入联系人',
      contactPhonePlaceholder: '请输入联系电话',
      contactEmailPlaceholder: '请输入邮箱',
      headquartersPlaceholder: '请输入总部地址',
      merchantDescPlaceholder: '请输入商户简介',
      websitePlaceholder: '请输入官方网站',
      merchantNameRequired: '商户名称不能为空',
      merchantCodeRequired: '商户编码不能为空',
      merchantLevelRequired: '商户等级不能为空',
      industryRequired: '所属行业不能为空',
      phoneFormatError: '请输入正确的手机号码',
      emailFormatError: '请输入正确的邮箱地址',
      // 快速新建品牌弹窗
      quickBrandTitle: '快速新建品牌',
      brandCreated: '品牌创建成功',
      brandCreateFailed: '创建品牌失败',
      brandTypeAnchor: '主力店',
      brandTypeSubAnchor: '次主力',
      brandTypeStandard: '散铺',
      levelInternational: '国际品牌',
      levelNational: '全国品牌',
      levelOrdinary: '普通商户',
      industryCatering: '餐饮',
      industryRetail: '零售',
      industryEntertainment: '娱乐',
      industryService: '服务',
      industryChildren: '儿童',
      industryOther: '其他',
      // 意向创建弹窗
      intentionFormTitle: '创建招商意向',
      intentionEditTitle: '编辑招商意向',
      selectShop: '选择铺位',
      shopLabel: '铺位',
      shopPlaceholder: '请选择铺位（支持多选）',
      shopRequired: '请至少选择一个铺位',
      batchTip: '已选择 {count} 个铺位，将为每个铺位分别创建意向记录',
      merchantInfo: '商户信息',
      merchantLabel: '商户',
      merchantPlaceholder: '请选择商户',
      merchantRequired: '请选择商户',
      brandLabel: '品牌',
      brandPlaceholder: '请选择品牌',
      signCompanyLabel: '收费主体',
      signCompanyPlaceholder: '请输入收费主体名称',
      leaseTerms: '租赁条款',
      proposedRent: '拟议租金',
      proposedRentRequired: '请输入拟议租金',
      rentCalculation: '计租方式',
      rentFixed: '固定租金',
      rentCommission: '扣点',
      rentGuaranteedHigher: '保底取高',
      proposedArea: '拟议面积',
      managementFee: '物业管理费',
      commissionRate: '扣点比例',
      guaranteedAmount: '保底金额',
      contractPeriod: '合同期限',
      startDate: '开始日期',
      startDateRequired: '请选择开始日期',
      endDate: '结束日期',
      endDateRequired: '请选择结束日期',
      rentFreePeriod: '免租期',
      annualIncreaseRate: '年递增率',
      feeInfo: '费用信息',
      addFeeItem: '添加费用项',
      feeItemName: '费用项目',
      feeItemAmount: '金额（元）',
      feeItemRefundable: '可退',
      feeItemRemark: '备注',
      feeItemSelectPlaceholder: '请选择费用项',
      feeItemTotal: '费用合计',
      feeItemEmpty: '暂无费用项，请点击"添加费用项"',
      feeItemDuplicate: '该费用项已添加',
      depositAmount: '保证金',
      paymentMethod: '付款方式',
      payMonthly: '月付',
      payQuarterly: '季付',
      payYearly: '年付',
      intentionDepositStatus: '意向金状态',
      depositUnpaid: '未缴纳',
      depositPaid: '已缴纳',
      depositRefunded: '已退还',
      depositPaidAmount: '已缴意向金',
      otherInfo: '其他',
      businessPlanLabel: '经营计划',
      businessPlanPlaceholder: '请输入经营计划',
      specialRequirements: '特殊要求',
      specialRequirementsPlaceholder: '请输入特殊要求',
      intentionCreateSuccess: '创建意向成功',
      intentionEditSuccess: '编辑意向成功',
      intentionBatchCreateSuccess: '成功创建 {count} 条意向',
      intentionCreateFailed: '创建意向失败',
      selectDatePlaceholder: '选择日期',
      // 铺位进度标签
      progressRented: '已入驻',
      progressSigned: '已签约',
      progressIntention: '意向中',
      progressNegotiating: '洽谈中',
      progressReserved: '预留',
      progressMaintenance: '维修中',
      progressVacant: '待招商',
      // 洽谈记录弹窗
      negotiationFormTitle: '新增洽谈记录',
      currentShop: '当前铺位',
      negotiationType: '洽谈方式',
      negotiationTypePhone: '电话',
      negotiationTypeFace: '面谈',
      negotiationTypeWechat: '微信',
      negotiationTypeEmail: '邮件',
      negotiationTypeOther: '其他',
      negotiationDate: '洽谈日期',
      negotiationContent: '洽谈内容',
      negotiationContentPlaceholder: '请输入洽谈内容',
      negotiationResult: '洽谈结果',
      resultPending: '待跟进',
      resultInterested: '有意向',
      resultNotInterested: '无意向',
      resultReached: '已达成',
      resultNone: '未达成',
      resultPreliminary: '初步达成',
      resultFull: '完全达成',
      nextFollowDate: '下次跟进',
      negotiationTypeRequired: '请选择洽谈方式',
      negotiationDateRequired: '请选择洽谈日期',
      negotiationContentRequired: '请输入洽谈内容',
      negotiationCreateSuccess: '新增洽谈记录成功',
      negotiationCreateFailed: '新增洽谈记录失败',
      // 洽谈详情弹窗
      negotiationDetailTitle: '洽谈记录详情',
      detailBasicInfo: '基本信息',
      detailNegotiationType: '洽谈方式',
      detailNegotiationDate: '洽谈日期',
      detailLocation: '洽谈地点',
      detailNegotiator: '洽谈负责人',
      detailParticipants: '参与人员',
      detailContentSection: '洽谈内容',
      detailMerchantRequirements: '商户需求',
      detailProposedSolution: '我方提议',
      detailNextSteps: '下一步计划',
      detailResultSection: '洽谈结果',
      detailProbability: '成功概率',
      detailFollowUpDate: '跟进日期',
      detailResultContinue: '继续跟进',
      detailResultNegotiate: '洽谈中',
      detailResultSign: '达成签约',
      detailResultTerminate: '终止',
      detailTypeVisit: '现场拜访',
      detailTypePhone: '电话沟通',
      detailTypeOnline: '线上沟通',
      detailLoadFailed: '加载洽谈记录详情失败',
      // 合同信息标签
      contractNo: '合同编号',
      contractTerm: '合同期限',
      standardRent: '标准租金',
    },

    // ==================== 业态规划 businessPlan ====================
    businessPlan: {
      title: '业态规划',
      // 筛选
      project: '项目',
      yearLabel: '年度',
      projectPlaceholder: '请选择项目',
      yearPlaceholder: '选择年度',
      // Tab
      tabProjectPlan: '项目业态规划',
      tabFloorPlan: '楼层业态分配',
      // 统计卡片
      totalShops: '总铺位数',
      totalArea: '总面积 (m²)',
      assignedBusinessType: '已分配业态',
      businessTypeCoverage: '业态覆盖率',
      // 表格列
      colBusinessType: '业态类型',
      colTargetPercent: '目标比例 %',
      colMinPercent: '最低 %',
      colMaxPercent: '最高 %',
      colActualPercent: '当前实际 %',
      colAreaSqm: '面积 (m²)',
      colShopCount: '铺位数',
      colDeviation: '偏差',
      colTarget: '目标%',
      colMin: '最低%',
      colMax: '最高%',
      colActual: '实际%',
      // 楼层筛选
      building: '楼栋',
      floor: '楼层',
      buildingPlaceholder: '请选择楼栋',
      floorPlaceholder: '请选择楼层',
      // 按钮
      exitFullscreen: '退出全屏',
      fullscreen: '全屏',
      initRatio: '初始化配比',
      initialize: '初始化',
      refreshActual: '刷新实际占比',
      batchSave: '批量保存',
      copyFromProject: '从项目级复制',
      resetToAverage: '重置为平均分配',
      // 汇总
      targetTotal: '目标合计:',
      actualTotal: '实际合计:',
      overLimit: '超限: {count}项',
      overLimitShort: '超限: {count} 项',
      footerTotal: '合计',
      // 空状态
      noDataInit: '暂无配比数据，请先初始化',
      selectProjectFirst: '请先选择项目',
      noDataCopy: '暂无配比数据，请先从项目级复制或初始化',
      selectBuildingFloor: '请先选择楼栋和楼层',
      noDataPlain: '暂无配比数据',
      // 提醒
      areaWarning: '该项目尚未配置可租赁面积，刷新实际占比将以铺位面积之和为基数。建议先在「组织管理」中配置项目可租赁面积。',
      // 确认
      initConfirm: '初始化将根据业态类型库生成默认配比数据，已有数据不受影响。是否继续？',
      initTitle: '确认初始化',
      copyConfirm: '从项目级复制将用项目级配比覆盖当前楼层配比，是否继续？',
      copyTitle: '确认复制',
      resetConfirm: '确定要重置为平均分配吗？这将覆盖当前的配置。',
      resetTitle: '确认重置',
      totalNotHundred: '当前目标比例合计为 {total}%，不等于 100%。是否仍要保存？',
      totalCheckTitle: '合计校验',
      targetMustBeHundred: '目标占比合计必须为100%',
      // 消息
      selectProjectMsg: '请先选择项目',
      selectFloorMsg: '请先选择楼层',
      initSuccess: '初始化成功',
      initFailed: '初始化失败',
      refreshSuccess: '刷新实际占比成功',
      refreshFailed: '刷新实际占比失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      copySuccess: '从项目级复制成功',
      copyFailed: '复制失败',
      resetSuccess: '重置为平均分配成功',
      resetFailed: '重置失败',
      loadProjectFailed: '加载项目业态配比失败',
      loadFloorFailed: '加载楼层业态配比失败',
      developingMsg: '项目级配比功能开发中',
      addRow: '新增',
      addDialogTitle: '新增业态配比',
      selectBusinessType: '请选择业态类型',
      selectBusinessTypeFirst: '请先选择业态类型',
      addSuccess: '新增成功',
      addFailed: '新增失败',
      deleteFailed: '删除失败',
      deleteConfirm: '是否确认删除该业态配比？',
      // BusinessPlanningPanel 特有
      projectRatio: '项目级配比',
      floorRatio: '楼层级配比',
      loadRatioFailed: '加载配比数据失败',
      refreshStats: '刷新统计',
    },

    // ==================== 行业选项（共享） ====================
    industry: {
      food: '餐饮',
      retail: '零售',
      entertainment: '娱乐',
      service: '服务',
      children: '儿童',
      other: '其他',
    },

    // ==================== 落位管理 placement ====================
    placement: {
      totalShops: '总铺位数',
      placedCount: '已落位铺位',
      placedBrandCount: '已落位品牌',
      placedRate: '落位率',
      businessTypeProgress: '业态落位进度',
      building: '建筑物',
      selectBuilding: '请选择建筑物',
      floor: '楼层',
      selectFloor: '请选择楼层',
      businessType: '业态',
      businessTypePlaceholder: '请输入业态名称',
      placementStatus: '落位状态',
      all: '全部',
      placed: '已落位',
      unplaced: '未落位',
      brandLevel: '品牌等级',
      brandLevelPlaceholder: '品牌等级',
      keyword: '关键字',
      keywordPlaceholder: '铺位名/品牌名/商户名',
      shopName: '资产名称',
      buildingName: '建筑物',
      floorName: '楼层',
      area: '面积(m2)',
      businessTypeName: '业态',
      brand: '品牌',
      noBrand: '无',
      merchant: '商户',
      proposedRent: '建议租金',
      unitYuan: '元',
      statusPlaced: '已落位',
      statusUnplaced: '未落位',
      statusConverted: '已转意向',
      statusCancelled: '已取消',
      brandInternational: '国际一线',
      brandNational: '国内一线',
      brandRegional: '区域品牌',
      brandLocal: '本地品牌',
      operation: '操作',
      assign: '分配',
      replace: '替换',
      clear: '清空',
      assignTitle: '分配落位',
      shop: '铺位',
      selectBrand: '请选择品牌',
      selectBusinessType: '请选择业态',
      newBusinessType: '新业态',
      businessTypeRequired: '请选择业态',
      selectMerchant: '请选择商户（可选）',
      proposedRentUnit: '元',
      confirm: '确 定',
      cancel: '取 消',
      replaceTitle: '替换品牌',
      currentBrand: '当前品牌',
      newBrand: '新品牌',
      selectNewBrand: '请选择新品牌',
      newMerchant: '新商户（可选）',
      assignBrandRequired: '请选择品牌',
      replaceBrandRequired: '请选择新品牌',
      assignSuccess: '分配成功',
      assignFailed: '分配失败',
      addBrand: '添加品牌',
      adjustBrand: '调整品牌',
      cancelPlacement: '取消落位',
      cancelPlacementConfirm: '确认取消铺位「{shopName}」的落位吗？',
      cancelPlacementTitle: '确认取消落位',
      cancelPlacementSuccess: '取消落位成功',
      replaceSuccess: '替换成功',
      clearConfirmMsg: '确认清空铺位「{shopName}」的落位信息？',
      clearConfirmTitle: '确认清空',
      clearSuccess: '清空成功',
      listView: '列表视图',
      canvasView: '画布视图',
      canvasPlaceholder: '画布可视化组件正在开发中，敬请期待...',
      backToList: '返回列表视图',
      selectFloorFirst: '请先选择楼层',
      canvasTip: '点击铺位可进行落位操作',
      multiAssignTitle: '模拟落位',
      shopInfo: '铺位信息',
      shopCode: '铺位号',
      shopType: '铺位类型',
      shopTypeRetail: '零售',
      shopTypeFood: '餐饮',
      shopTypeEntertainment: '娱乐',
      shopTypeService: '服务',
      filterIndustry: '行业业态',
      filterBrandLevel: '品牌等级',
      filterBrandType: '品牌类型',
      plannedBusinessType: '规划业态',
      placementBrands: '落位品牌',
      preferred: '首选',
      secondary: '次选',
      alternative: '备选',
      preferredBrandRequired: '请选择首选品牌',
      businessTypeRequired: '请选择业态',
      existingBrands: '已落位品牌',
      addMoreBrands: '追加品牌',
      statusLegend: '状态图例',
      shopDetail: '铺位详情',
    },

    // ==================== 快速意向 quickIntention ====================
    quickIntention: {
      title: '快速创建意向',
      merchant: '商户',
      selectMerchant: '请选择商户',
      proposedRent: '拟议租金',
      intentionDate: '意向日期',
      selectDate: '选择日期',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      cancel: '取消',
      confirm: '确定',
      merchantRequired: '请选择商户',
      proposedRentRequired: '请输入拟议租金',
      createSuccess: '创建意向成功',
      createFailed: '创建意向失败',
    },

    // ==================== 意向金管理 deposit ====================
    deposit: {
      title: '意向金管理',
      feeConfig: '费用配置',
      feeName: '费用名称',
      feeCode: '费用编码',
      feeItem: '费用项目',
      selectFeeItem: '请选择费用项',
      amount: '金额',
      remark: '备注',
      totalAmount: '费用合计',
      paymentRecords: '收款记录',
      receivePayment: '录入收款',
      recordNo: '记录编号',
      paymentMethod: '付款方式',
      paymentTime: '收款时间',
      payee: '收款人',
      recordStatus: '状态',
      recordDetail: '收款详情',
      // 付款方式
      cash: '现金',
      bankTransfer: '银行转账',
      alipay: '支付宝',
      wechat: '微信',
      check: '支票',
      // 收款状态
      statusPending: '待收款',
      statusReceived: '已收款',
      statusDeducted: '已抵扣',
      statusRefundPending: '退款中',
      statusRefunded: '已退款',
      // 统计
      receivedAmount: '已收款',
      availableDeduct: '可抵扣',
      // 操作
      deduct: '抵扣',
      refund: '退款',
      refundApplied: '已申请退款',
      // 弹窗字段
      deductAmount: '抵扣金额',
      availableAmount: '可用金额',
      refundAmount: '退款金额',
      refundableAmount: '可退金额',
      refundReason: '退款原因',
      deductedAmount: '已抵扣金额',
      effectiveTime: '生效时间',
    },

    // ==================== 正式落位 formalPlacement ====================
    formalPlacement: {
      title: '正式落位',
      candidateIntentions: '可落位意向',
      pendingPlacements: '待生效落位',
      effectivePlacements: '已生效落位',
      cancelledPlacements: '已取消',
      // Tab
      candidatesTab: '可落位意向',
      placementsTab: '落位记录',
      // 字段
      intentionNo: '意向编号',
      brandName: '品牌',
      merchantName: '商户',
      shopName: '资产',
      proposedRent: '建议租金',
      depositStatus: '意向金',
      placementNo: '落位编号',
      startDate: '进场日期',
      engineeringReqs: '工程要求',
      statusLabel: '状态',
      effectiveTime: '生效时间',
      cancelReason: '取消原因',
      // 状态
      statusPending: '待生效',
      statusEffective: '已生效',
      statusCancelled: '已取消',
      // 操作
      createPlacement: '发起落位',
      placementDetail: '落位详情',
      effect: '生效',
      cancelPlacement: '取消落位',
      effectConfirm: '确定要让该落位生效吗？',
      // 校验
      validateError: '校验失败，无法发起落位',
      // 搜索
      keyword: '关键字',
      noRecords: '暂无落位记录',
    },

    // ==================== 商品管理 product ====================
    product: {
      title: '商品管理',
      productCode: '商品编码',
      productName: '商品名称',
      merchantName: '商户名称',
      contractNo: '合同编号',
      commissionRate: '扣率(%)',
      productType: '商品类型',
      isDefault: '默认商品',
      status: '状态',
      remark: '备注',
      addProduct: '新增商品',
      editProduct: '编辑商品',
      productDetail: '商品详情',
      productNameRequired: '商品名称不能为空',
      merchantRequired: '请选择商户',
      contractRequired: '请选择合同',
      deleteConfirm: '确定要删除选中的商品吗？',
      defaultCannotDelete: '默认商品不可删除',
      salesLinkedCannotDelete: '已关联销售记录的商品不可删除',
      bindingCannotDelete: '商品已绑定合同，请先解绑',
      typeSingle: '单品',
      typeCategory: '品类',
      typeLease: '租赁',
      typeJoint: '联营',
      typeSelf: '自营',
      yes: '是',
      no: '否',
      enable: '启用',
      disable: '停用',
      pendingGenerate: '待生效自动生成',
      viewProductList: '查看商品列表',
      defaultProductInfo: '默认商品信息',
      // 自然属性
      category: '品类',
      categoryPlaceholder: '请选择品类',
      brand: '品牌',
      brandPlaceholder: '请选择品牌',
      barcode: '条形码',
      sku: 'SKU编码',
      specification: '规格型号',
      unit: '计量单位',
      categoryName: '分类',
      imageUrl: '商品图片',
      // 计量单位选项
      unitPiece: '件',
      unitKg: 'kg',
      unitSet: '套',
      unitCup: '杯',
      unitPortion: '份',
      unitBox: '盒',
      unitBottle: '瓶',
      // 录入操作
      addRow: '新增行',
      batchSave: '全部保存',
      batchDelete: '批量删除',
      excelImport: 'Excel导入',
      downloadTemplate: '下载模板',
      editMode: '编辑模式',
      saveRow: '保存',
      cancelRow: '取消',
      continueAdd: '继续新增行',
      // 绑定相关
      binding: '绑定',
      bindingCount: '绑定合同数',
      bindProduct: '绑定商品',
      unbind: '解绑',
      retailPrice: '零售价',
      costPrice: '采购价',
      wholesalePrice: '批发价',
      settlementMethod: '经营方式',
      salesDeptName: '销售部门',
      settlementRent: '租赁',
      settlementCommission: '扣点',
      settlementJoint: '联营',
      settlementPurchase: '进销差',
      // 新增字段 - 基本信息
      fullName: '商品全称',
      fullNamePlaceholder: '商品完整名称',
      pinyinCode: '拼音码',
      pinyinCodePlaceholder: '根据商品名称自动生成',
      barcodeType: '条码类型',
      barcodeTypeEan13: 'EAN-13',
      barcodeTypeCode128: 'CODE-128',
      barcodeTypeUpcA: 'UPC-A',
      barcodeTypeCustom: '自定义',
      // 新增字段 - 标识与规格
      scanBarcode: '扫描条码',
      // 新增字段 - 物理属性
      origin: '产地',
      originPlaceholder: '生产地',
      season: '季节',
      seasonSpring: '春',
      seasonSummer: '夏',
      seasonAutumn: '秋',
      seasonWinter: '冬',
      seasonAll: '四季',
      seasonNone: '无',
      shelfLifeDays: '保质期(天)',
      weight: '净重(kg)',
      colorPattern: '商品花色',
      colorPatternPlaceholder: '颜色/图案',
      qualityGrade: '质量等级',
      qualityGradeQualified: '合格品',
      qualityGradeFirst: '一等品',
      qualityGradeTop: '优等品',
      textureContent: '质地含量',
      textureContentPlaceholder: '如：棉80% 涤纶20%',
      // 新增字段 - 税务信息
      taxInfo: '税务信息',
      customsTaxRate: '关税税率(%)',
      consumptionTaxRate: '消费税率(%)',
      inputTaxRate: '进项税率(%)',
      outputTaxRate: '销项税率(%)',
      taxCategory: '税收分类编码',
      taxCategoryPlaceholder: '税收分类编码',
      collapseTaxInfo: '点击左侧箭头收起/展开',
      // 新增字段 - 标记位
      flags: '标记',
      isBulk: '散装',
      isSpecialSale: '特卖商品',
      allowDecimalQty: '允许数量小数',
      isFresh: '生鲜',
      // 合同绑定新增字段
      purchasePrice: '采购价',
      wholesalePrice: '批发价',
      memberPrice: '会员价',
      purchasePriceShort: '采购',
      wholesalePriceShort: '批发',
      memberPriceShort: '会员',
      retailPriceShort: '零售',
      // SKU管理
      skuManage: 'SKU拆码管理',
      skuConfig: '拆码配置',
      dimName: '维度名称',
      dimNamePlaceholder: '如：色号 / 口味',
      dim2NamePlaceholder: '选填，如：尺码 / 容量',
      dimValues: '维度选项值',
      dimValuesPlaceholder: '输入后回车添加',
      skuPreview: '自动拆码预览',
      skuPreviewCount: '个SKU',
      skuBasedOnConfig: '（基于当前维度配置）',
      confirmSplit: '确认拆码',
      manualAddSku: '手动添加SKU',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      skuBarcode: 'SKU条码',
      pluCode: 'PLU码',
      dim1Name: '维度1',
      dim1Value: '维度1值',
      dim2Name: '维度2',
      dim2Value: '维度2值',
      isSalesReport: '销售上报',
      isInventoryManage: '库存管理',
      sort: '排序',
      skuEmpty: '暂未生成SKU，请在上方配置拆码维度后点击"确认拆码"',
      skuListInfo: 'SKU列表',
      skuImport: '导入SKU',
      skuExportEmpty: '导出空表格',
      skuCount: 'SKU数',
      skuCountUnit: '个',
      bindingNote: '说明',
      bindingNoteContent: '商品的零售价、采购价、批发价、会员价、结算扣率由合同维度决定。单品类型商品使用绑定合同中设置的零售价进行结算；品类类型商品则由收银员在POS交易时手动输入实际销售价格。',
      // 表单模式
      backToList: '返回列表',
      saveSuccess: '保存成功',
      editMode: '编辑模式',
      addMode: '新增模式',
      // Tab
      tabBasic: '基本信息',
      tabBinding: '合同绑定',
      tabSku: 'SKU拆码管理',
      // 导入
      importStep1: '下载模板',
      importStep2: '上传文件',
      importStep3: '校验结果',
      importStep4: '确认导入',
      importTitle: '商品批量导入',
      importTemplateDesc: '请先下载导入模板，按照模板格式填写数据',
      importUploadTip: '支持 .xlsx/.xls 格式，单次最多1000条',
      importValidating: '正在校验数据...',
      importTotalRows: '总行数',
      importValidRows: '有效行',
      importInvalidRows: '无效行',
      importSuccess: '导入成功',
      importErrorDetail: '错误详情',
      // 绑定弹窗
      bindingTitle: '合同绑定管理',
      bindingEmpty: '暂无绑定合同',
      addBinding: '新增绑定',
      selectContract: '选择合同',
      selectContractPlaceholder: '请选择要绑定的合同',
      selectMerchant: '选择商户',
      unbindConfirm: '确定要解绑该商品与合同的关系吗？',
      unbindSuccess: '解绑成功',
      bindSuccess: '绑定成功',
      updateBindingSuccess: '更新绑定成功',
      isDefaultProduct: '默认商品',
      sortOrder: '排序',
      // v4.3 新增
      productStatus: '商品状态',
      businessStatus: '业务状态',
      businessStatusActive: '有生效合同',
      businessStatusPartial: '部分到期',
      businessStatusExpired: '全部到期',
      businessStatusUnbound: '未绑定',
      contractStatus: '合同状态',
      contractStatusDraft: '草稿',
      contractStatusPending: '待审批',
      contractStatusActive: '已生效',
      contractStatusExpired: '已到期',
      contractStatusTerminated: '已终止',
      assetName: '铺位',
      contractEnd: '合同到期日',
      basicInfo: '基本信息',
      contractBinding: '合同绑定',
      removeBindingRow: '移除',
      removeBindingConfirm: '确定移除该绑定行吗？',
      imagePlaceholder: '点击上传商品图片',
      importMergeHint: '同名商品将自动合并，不同合同信息分别绑定',
      // 页面级别
      pageTitle: '商品管理',
      totalCount: '共 {count} 件商品',
      keywordSearch: '关键字搜索',
      keywordPlaceholder: '商品名称 / 编码 / 条码 / SKU',
      exportTip: '导出功能开发中',
      autoGenerate: '（自动生成）',
      codeAutoGenerate: '自动生成，可手动编辑',
      codeManualInput: '请输入商品编码',
      productCodeRequired: '请输入商品编码',
      productNamePlaceholder: '请输入商品名称',
      clickUpload: '点击上传\n商品图片',
      imageHint: '支持 JPG/PNG\n建议 800×800\n不超过 5MB',
      productImage: '商品图片',
      barcodePlaceholder: '扫描或输入条码',
      specPlaceholder: '规格/型号',
      identityAndSpec: '标识与规格',
      physicalAttr: '物理属性',
      materialContent: '质地含量',
      materialContentPlaceholder: '如：棉80% 涤纶20%',
      clickToToggle: '（点击左侧箭头收起/展开）',
      remarkPlaceholder: '请输入备注信息...',
      daysPlaceholder: '天',
      kgPlaceholder: 'kg',
      skuEmptyTip: '暂未生成SKU，请在上方配置拆码维度后点击"确认拆码"',
      addManualSku: '手动添加SKU',
      dim1NameLabel: '拆码维度1名称（如：色号 / 口味）',
      dim2NameLabel: '拆码维度2名称（如：尺码 / 容量）【选填】',
      dim1ValuesLabel: '维度1选项值',
      dim2ValuesLabel: '维度2选项值',
      tagInputPlaceholder: '输入后回车添加',
      skuList: 'SKU列表',
      importSku: '导入SKU',
      boundCount: '已绑定 {count} 个合同',
      selfPurchaseBinding: '自营采购合同关联',
      purchasePrice: '采购价',
      wholesalePrice: '批发价',
      memberPrice: '会员价(元)',
      bindingNoteTitle: '说明',
      statusActive: '生效中',
      statusEditing: '编辑中',
      statusDraft: '草稿',
      viewMode: '查看模式',
      exportData: '导出',
      // 审核工作流
      approvalStatus: '审核状态',
      approvalDraft: '草稿',
      approvalApproved: '已审核',
      approve: '审核通过',
      approveConfirm: '确认审核通过该商品？审核通过后核心信息和价格将不可修改。',
      approveSuccess: '审核成功',
      skuRequired: '商品必须至少有一条SKU记录，请先添加SKU',
      copyProduct: '复制',
      copySuccess: '已复制商品信息，编辑后保存即可创建新商品',
    },

    // ==================== 合同退场 termination ====================
    termination: {
      // 标题
      createTitle: '发起退场申请',
      editTitle: '编辑退场申请',
      detailTitle: '退场详情',
      tabLabel: '退场信息',
      tabTitle: '退场信息',
      initTermination: '发起退场',
      // 退场类型
      type: '退场类型',
      terminationType: '退场类型',
      normalExpiry: '正常到期退场',
      earlyTermination: '提前终止退场',
      // 基本信息
      exitDate: '退场日期',
      exitDatePlaceholder: '请选择退场日期',
      exitDateRequired: '请选择退场日期',
      contractEnd: '合同到期日',
      exitReason: '退场原因',
      exitReasonPlaceholder: '请选择退场原因',
      reasonExpired: '合同到期',
      reasonBreach: '违约',
      reasonNegotiated: '协商解除',
      reasonOther: '其他',
      contractNo: '合同编号',
      merchantName: '商户名称',
      assetName: '资产名称',
      remark: '备注',
      remarkPlaceholder: '请输入备注说明',
      createAndCalc: '创建并计算费用',
      // 费用结算
      penaltyAmount: '违约金',
      penaltyAmountPlaceholder: '请输入违约金金额',
      totalOutstanding: '应收未收',
      totalRefundable: '应退金额',
      depositAmount: '押金金额',
      netSettlement: '净结算',
      settlementRemark: '结算备注',
      viewSettlement: '查看费用结算',
      unpaidPlans: '未付账单明细',
      refundableFees: '可退费用明细',
      // 状态
      statusDraft: '草稿',
      statusPending: '审批中',
      statusCompleted: '已完成',
      statusCancelled: '已取消',
      statusTerminating: '退场中',
      // 审批
      approvalStatus: '审批状态',
      submitApproval: '提交审批',
      submitConfirmTitle: '提交退场审批',
      submitConfirmMsg: '提交后将进入审批流程（招商确认→财务结算确认→运营交还确认），确认提交？',
      submitSuccess: '已提交审批',
      submitFailed: '提交失败',
      // 操作
      noRecord: '暂无退场记录',
      createBy: '创建人',
      createTime: '创建时间',
      deleteConfirmTitle: '删除确认',
      deleteConfirmMsg: '确定删除该退场申请？',
      deleteSuccess: '已删除',
      deleteFailed: '删除失败',
      createSuccess: '退场申请创建成功',
      createFailed: '创建退场申请失败',
      loadFailed: '加载退场记录失败',
      settlementLoadFailed: '加载结算信息失败',
      // 退场管理页面
      pageTitle: '退场管理',
      keywordSearch: '关键字',
      keywordPlaceholder: '退场编号/合同号/商户/铺位',
      typeFilter: '退场类型',
      statDraft: '草稿',
      statPending: '审批中',
      statCompleted: '已完成',
      statCancelled: '已取消',
      colTerminationNo: '退场编号',
      colContractNo: '合同编号',
      colMerchant: '商户名称',
      colAsset: '资产名称',
      colType: '退场类型',
      colExitDate: '退场日期',
      colNetSettlement: '净结算',
      colStatus: '状态',
      goContract: '查看合同',
      processProgress: '流程进度',
      nodeRecruitment: '招商确认',
      nodeFinance: '财务结算',
      nodeOperation: '运营交还',
      statisticsFailed: '加载统计失败',
    },

    // ==================== 商户账号管理 account ====================
    account: {
      title: '商户账号管理',
      subtitle: '管理商户关联的系统账号',
      merchantName: '商户名称',
      accountCount: '账号数量',
      addAccount: '新增账号',
      unbind: '解绑',
      unbindConfirm: '确认解绑该账号？解绑后仅清除商户关联，账号本身保留。',
      unbindWx: '解绑微信',
      unbindWxConfirm: '确认解绑该账号的微信小程序？解绑后需重新绑定才能用微信登录。',
      unbindWxSuccess: '微信解绑成功',
      resetPassword: '重置密码',
      resetPasswordConfirm: '确认重置该账号的密码？',
      addSuccess: '账号创建成功',
      generatedPassword: '生成的密码',
      copyPassword: '复制密码',
      copiedSuccess: '密码已复制到剪贴板',
      phone: '手机号',
      realname: '姓名',
      lastLogin: '最近登录',
      noAccounts: '暂无关联账号',
      phonePlaceholder: '请输入手机号',
      realnamePlaceholder: '请输入姓名',
      remarkPlaceholder: '请输入备注（选填）',
      username: '用户名',
      passwordDialogTitle: '账号密码信息',
      passwordTip: '请妥善保管以下密码，关闭后将无法再次查看',
      enableSuccess: '启用成功',
      disableSuccess: '禁用成功',
      unbindSuccess: '解绑成功',
      resetSuccess: '密码重置成功',
      keywordPlaceholder: '商户名称/编码/手机号',
      userType: '账号类型',
      staffAndMerchant: '商管+商户',
      merchantOnly: '商户',
      wxBound: '微信绑定',
      wxBoundYes: '已绑定',
      wxBoundNo: '未绑定',
      wxNickname: '微信昵称',
      wxAvatar: '微信头像',
      wxAccount: '微信账号',
      reusedSuccess: '已有账号已关联到该商户，使用原密码登录',
      bindExisting: '绑定已有账号',
      searchUser: '选择用户',
      searchUserPlaceholder: '输入用户名/姓名/手机号搜索',
      searchMinLength: '请输入至少2个字符',
      noSearchResult: '未找到可绑定的用户',
      confirmBind: '确认绑定',
      bindSuccess: '账号绑定成功',
      bindStores: '可操作门店',
      bindStoresPlaceholder: '请选择门店（可多选）',
      bindStoresRequired: '请至少选择一个门店',
      storeOptionsEmpty: '暂无可用门店，请先在组织管理中维护门店',
      storeColumn: '门店',
      editStores: '配置门店',
      editStoresTitle: '配置可操作门店',
      editStoresSuccess: '门店配置已更新',
      defaultStore: '默认门店',
    },

    // ==================== 发票管理 invoice ====================
    invoice: {
      title: '发票管理',
      management: '发票管理',
      // 开票申请（商户端）
      requestTitle: '开票申请',
      myRequests: '我的申请',
      createRequest: '申请开票',
      selectBills: '选择账单',
      selectBillsPlaceholder: '点击选择需要开票的账单',
      billsUnit: '笔',
      addMore: '添加更多',
      billSelection: '账单选择',
      deliverType: '交付方式',
      deliverTypeWechat: '微信卡包',
      deliverTypeEmail: '邮箱发送',
      deliverTypeEmailHint: '发票将发送至以下邮箱',
      buyerEmail: '收票邮箱',
      buyerEmailPlaceholder: '请输入收票邮箱',
      remark: '备注',
      remarkPlaceholder: '请输入备注（选填）',
      requestNo: '申请编号',
      requestTime: '申请时间',
      totalAmount: '开票金额',
      titleType: '抬头类型',
      titleTypePersonal: '个人',
      titleTypeCompany: '单位',
      buyerName: '发票抬头',
      buyerTaxNo: '纳税人识别号',
      buyerPhone: '购买方电话',
      status: '状态',
      invoiceStatus: '开票状态',
      // 账单开票状态
      invoiceStatusNone: '可开票',
      invoiceStatusApplied: '已申请',
      invoiceStatusInvoicing: '开票中',
      invoiceStatusInvoiced: '已开票',
      invoiceStatusFailed: '开票失败',
      invoiceStatusRedFlushed: '已红冲',
      applicant: '申请人',
      // 申请状态
      statusPending: '待开票',
      statusProcessing: '开票中',
      statusDone: '已完成',
      statusFailed: '失败',
      // 开票处理（财务端）
      processTitle: '开票处理',
      pendingRequests: '待开票申请',
      issueInvoice: '开具发票',
      invoiceType: '发票类型',
      invoiceTypeSpecial: '专用发票',
      invoiceTypeOrdinary: '普通发票',
      invoiceTypePending: '待定',
      confirmIssue: '确认开票',
      confirmIssueTip: '确认开具该发票？开票后将无法撤销。',
      issueSuccess: '开票申请已提交，请稍后查询开票状态',
      issueFailed: '开票失败',
      // 发票记录
      recordTitle: '发票记录',
      recordList: '发票列表',
      recordNo: '发票记录编号',
      invoiceNo: '发票号码',
      invoiceDate: '开票日期',
      invoiceAmount: '发票金额',
      elecInvoiceNumber: '数电票号码',
      invoiceCode: '发票代码',
      invoiceSerialNo: '发票流水号',
      exTaxAmount: '不含税金额',
      invoiceInfo: '发票信息',
      buyerInfo: '购方信息',
      platform: '开票平台',
      pdfUrl: '发票PDF',
      viewPdf: '查看PDF',
      downloadPdf: '下载PDF',
      qrCode: '发票二维码',
      redFlush: '发票红冲',
      redInvoice: '红字发票',
      redFlushConfirm: '确认红冲该发票？',
      redFlushReason: '红冲原因',
      redFlushReasonPlaceholder: '请输入红冲原因',
      redFlushSuccess: '红冲成功',
      redFlushFailed: '红冲失败',
      deliver: '补交付',
      deliverConfirm: '确认补交付发票？',
      deliverSuccess: '补交付成功',
      deliverFailed: '补交付失败',
      viewDetail: '查看详情',
      // 详情
      detailTitle: '发票详情',
      platform: '开票平台',
      platformBillNo: '平台流水号',
      invoiceTypeLabel: '发票类型',
      invoiceItems: '发票明细',
      goodsName: '商品名称',
      taxClassifyCode: '税收分类编码',
      unit: '单位',
      quantity: '数量',
      unitPrice: '单价',
      amount: '金额',
      taxRate: '税率',
      taxAmount: '税额',
      // 关联账单
      relatedBills: '关联账单',
      billNo: '账单编号',
      // 红冲信息
      redFlushInfo: '红冲信息',
      redFlushTime: '红冲时间',
      redFlushBy: '红冲操作人',
      // 商户开票信息
      merchantInvoiceInfo: '商户开票信息',
      isDefault: '默认',
      titleName: '开票抬头',
      taxNo: '税号',
      phone: '联系电话',
      email: '接收邮箱',
      bankName: '开户银行',
      bankAccount: '银行账号',
      address: '注册地址',
      // 交付信息
      deliverInfo: '交付信息',
      buyerEmail: '收票邮箱',
      // 开票信息选择
      selectInvoiceInfo: '选择开票信息',
      selectInvoiceInfoPlaceholder: '请选择开票信息',
      selectInvoiceInfoRequired: '请选择开票信息',
      manageInvoiceInfo: '管理开票信息',
      goToManageInvoiceInfo: '前往管理开票信息',
      noInvoiceInfo: '该商户暂无开票信息',
      setDefaultSuccess: '已设为默认开票信息',
      setDefaultFailed: '设置默认开票信息失败',
      // 提示信息
      selected: '已选',
      noPaidBills: '暂无可开票账单',
      selectAtLeastOne: '请至少选择一条账单',
      requestFailed: '开票申请失败',
      emailRequired: '请输入收票邮箱',
      invalidEmail: '请输入有效的邮箱地址',
      requestSuccess: '开票申请已提交',
      requestFailed: '申请提交失败',
      // 账单选择
      billableAmount: '可开票金额',
      billFeeDetail: '账单费用明细',
      defaultGoodsName: '不动产租赁服务',
      noFeeItems: '暂无费用明细',
      invoiceGoodsName: '开票商品名称',
      // 汇总数据
      pendingAmount: '待开票金额',
      todayIssued: '今日已开',
      monthlyTotal: '本月开票总额',
      totalCount: '发票总数',
      specialCount: '专票数量',
      ordinaryCount: '普票数量',
    },

    // ==================== 商户旅程 journey ====================
    journey: {
      title: '商户旅程',
      searchPlaceholder: '搜索商户名称或品牌',
      noMerchant: '请选择商户查看旅程',
      merchantProfile: '商户概况',
      firstContact: '首次接触',
      relatedShops: '关联铺位',
      contractCount: '合同数',
      currentStatusLabel: '当前状态',
      timelineTitle: '生命周期时间轴',
      stageFirstContact: '首次接触',
      stageIntention: '意向达成',
      stageContractSigned: '合同签约',
      stageRenovation: '装修进场',
      stageOperation: '开业经营',
      stageExit: '退场离场',
      statusCompleted: '已完成',
      statusInProgress: '进行中',
      statusUpcoming: '待开始',
      statusRecruiting: '招商中',
      statusNegotiating: '洽谈中',
      statusIntention: '意向中',
      statusContracting: '签约中',
      statusOperating: '经营中',
      statusExited: '已退场',
      stageDetail: '阶段详情',
      negotiationRounds: '洽谈轮次',
      intentionShop: '意向铺位',
      intentionStatus: '意向状态',
      contractNo: '合同编号',
      leaseShop: '租赁铺位',
      leasePeriod: '租赁期限',
      rentMode: '租金模式',
      approvalStatus: '审批状态',
      renovationType: '装修类型',
      renovationPeriod: '装修周期',
      renovationProgress: '装修进度',
      monthlySales: '月度销售趋势',
      totalSales: '累计销售',
      avgMonthlySales: '月均销售',
      paymentCount: '缴费次数',
      exitReason: '退场原因',
      exitDate: '退场日期',
      viewContract: '查看合同',
      viewShop: '查看铺位',
      noStages: '暂无旅程数据',
      // ==================== 总览 overview ====================
      overview: {
        backToList: '返回总览',
        kpiActive: '在营商户',
        kpiConversion: '意向→签约转化率',
        kpiNewThisMonth: '本月新增接触',
        kpiWarnings: '预警商户',
        funnelTitle: '阶段转化漏斗',
        statusTitle: '商户状态分布',
        newTrendTitle: '近6月新增趋势',
        salesTrendTitle: '近6月销售总额',
        matrixTitle: '商户旅程矩阵',
        filterAll: '全部',
        filterWarning: '仅预警',
        colMerchant: '商户',
        colBrand: '品牌',
        colStage: '阶段进度',
        colStatus: '状态',
        colContracts: '合同数',
        colWarning: '预警',
        colAction: '操作',
        stageFirstContact: '首次接触',
        stageIntention: '意向',
        stageContractSigned: '签约',
        stageRenovation: '装修',
        stageExit: '已退场',
        warnRenovationOverdue: '装修超期',
        warnIntentionStalled: '意向滞留超30天',
        warnContractExpiring: '合同60天内到期',
        warnShortRenovationOverdue: '装修',
        warnShortIntentionStalled: '滞留',
        warnShortContractExpiring: '临期',
        statusMap: {
          OPERATING: '在营',
          CONTRACTING: '签约中',
          NEGOTIATING: '意向洽谈',
          RECRUITING: '招商接触',
          EXITED: '已退场',
        },
        detail: '详情',
        loadFailed: '总览加载失败',
        retry: '重试',
        empty: '暂无商户旅程数据',
      },
    },

    // ==================== 通用 ====================
    common: {
      hideSearch: '隐藏搜索',
      showSearch: '显示搜索',
      warning: '警告',
      selectDataFirst: '请选择要删除的数据',
      addSuccess: '新增成功',
      editSuccess: '修改成功',
      setSuccess: '设置成功',
      cancelSuccess: '取消成功',
      pleaseInput: '请输入',
      pleaseSelect: '请选择',
    },
  },
}
